/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-unknown-property */
/* eslint-disable no-useless-escape */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
/* eslint-disable react/jsx-props-no-multi-spaces */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import { useState, useEffect, useRef } from "react";
import { Link as RouterLink } from "react-router-dom";
import PropTypes from "prop-types";
import AdjustOutlinedIcon from "@mui/icons-material/AdjustOutlined";
import {
  Alert,
  Autocomplete,
  Avatar,
  Box,
  Button,
  Card,
  CircularProgress,
  createFilterOptions,
  Grid,
  Link,
  // Switch,
  TextField,
  Tooltip,
  Typography,
  Stepper,
  Step,
  StepLabel,
} from "@material-ui/core";
import {
  DataGrid,
  GridActionsCellItem,
  frFR,
  GridToolbarQuickFilter,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid";
import { ProgressBar } from ".";
import DeleteIcon from "@material-ui/icons/Delete";
import SendIcon from "@mui/icons-material/Send";
import FolderZipIcon from "@mui/icons-material/FolderZip";
import DoneAllOutlinedIcon from "@mui/icons-material/DoneAllOutlined";
import AccessTimeOutlinedIcon from "@mui/icons-material/AccessTimeOutlined";
import HorizontalRuleRoundedIcon from "@mui/icons-material/HorizontalRuleRounded";
import UploadOutlinedIcon from "@mui/icons-material/UploadOutlined";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import CachedRoundedIcon from "@mui/icons-material/CachedRounded";
import AttachEmailIcon from "@mui/icons-material/AttachEmail";
import AssignmentIcon from "@mui/icons-material/Assignment";
// import ListIcon from '@material-ui/icons/List';
import { sessionApi } from "../../../api/sessionApi";
import { formationApi } from "../../../api/formationApi";
import * as Yup from "yup";
import { Formik } from "formik";
import * as moment from "moment";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import toast from "react-hot-toast";
import useAuth from "../../../hooks/useAuth";
// import AttestationPDF from '../../AttestationPDF';
// import { pdf } from '@react-pdf/renderer';
// import PDFMerger from 'pdf-merger-js';
// import * as XLSX from 'xlsx';
import Label from "../../Label";
import { customerApi } from "../../../api/customerApi";
import { Chip, ClickAwayListener, LinearProgress } from "@mui/material";
import { useTheme } from "@emotion/react";
import SessionEmailSendDialog from "./SessionEmailSendDialog";

function renderProgress(params) {
  if (params.value === null) {
    return <ProgressBar value={Number(0)} />;
  }
  return <ProgressBar value={Number(parseInt(params.value, 10))} />;
}

// ── Helpers de présentation des cellules ──
const LEARNER_AVATAR_GRADIENTS = [
  ['#3b82f6', '#1d4ed8'],
  ['#8b5cf6', '#6d28d9'],
  ['#06b6d4', '#0e7490'],
  ['#10b981', '#047857'],
  ['#f59e0b', '#b45309'],
  ['#ec4899', '#be185d'],
  ['#6366f1', '#4338ca'],
  ['#14b8a6', '#0f766e'],
];

const hashStr = (str = '') => {
  let h = 0;
  for (let i = 0; i < str.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    h = str.charCodeAt(i) + ((h << 5) - h);
  }
  return Math.abs(h);
};

const initialsOf = (first = '', last = '') => `${(first || '').charAt(0)}${(last || '').charAt(0)}`.toUpperCase() || 'A';

const getLearnerStatusStyle = (status) => {
  switch (status) {
    case 'Inscrit': return { color: '#059669', bg: 'rgba(16, 185, 129, 0.1)', border: 'rgba(16, 185, 129, 0.25)' };
    case 'En attente':
    case 'À transférer': return { color: '#d97706', bg: 'rgba(245, 158, 11, 0.12)', border: 'rgba(245, 158, 11, 0.25)' };
    case 'InscritD': return { color: '#0d9488', bg: 'rgba(20, 184, 166, 0.1)', border: 'rgba(20, 184, 166, 0.25)' };
    case 'Décalé': return { color: '#8b5cf6', bg: 'rgba(139, 92, 246, 0.1)', border: 'rgba(139, 92, 246, 0.25)' };
    case '- de 5 personnes':
    case 'Annulation':
    case 'À décaler': return { color: '#dc2626', bg: 'rgba(239, 68, 68, 0.1)', border: 'rgba(239, 68, 68, 0.25)' };
    case 'Désinscrit': return { color: '#be123c', bg: 'rgba(225, 29, 72, 0.12)', border: 'rgba(225, 29, 72, 0.28)' };
    default: return { color: '#64748b', bg: 'rgba(100, 116, 139, 0.1)', border: 'rgba(100, 116, 139, 0.22)' };
  }
};

const getEtatStyle = (etat) => {
  switch (etat) {
    case 'Terminé': return { color: '#059669', bg: 'rgba(16, 185, 129, 0.1)', border: 'rgba(16, 185, 129, 0.25)' };
    case 'En cours': return { color: '#2563eb', bg: 'rgba(59, 130, 246, 0.1)', border: 'rgba(59, 130, 246, 0.25)' };
    case 'Non terminé': return { color: '#dc2626', bg: 'rgba(239, 68, 68, 0.1)', border: 'rgba(239, 68, 68, 0.25)' };
    case 'Pas commencé': return { color: '#64748b', bg: 'rgba(100, 116, 139, 0.1)', border: 'rgba(100, 116, 139, 0.22)' };
    default: return { color: '#64748b', bg: 'rgba(100, 116, 139, 0.08)', border: 'rgba(100, 116, 139, 0.18)' };
  }
};

const getQualificationStyle = (qual) => {
  switch (qual) {
    case 'sera présent': 
      return { color: '#059669', bg: 'rgba(16, 185, 129, 0.1)', border: 'rgba(16, 185, 129, 0.25)' };
    case 'sera absent': 
      return { color: '#dc2626', bg: 'rgba(239, 68, 68, 0.1)', border: 'rgba(239, 68, 68, 0.25)' };
    case 'relance en cours': 
      return { color: '#2563eb', bg: 'rgba(59, 130, 246, 0.1)', border: 'rgba(59, 130, 246, 0.25)' };
    case 'paiement confirmé': 
      return { color: '#0f766e', bg: 'rgba(13, 148, 136, 0.1)', border: 'rgba(13, 148, 136, 0.25)' };
    case 'paiement non reçu': 
      return { color: '#d97706', bg: 'rgba(245, 158, 11, 0.1)', border: 'rgba(245, 158, 11, 0.25)' };
    case 'NRP': 
      return { color: '#4f46e5', bg: 'rgba(99, 102, 241, 0.1)', border: 'rgba(99, 102, 241, 0.25)' };
    case 'NRP + Mail': 
      return { color: '#7c3aed', bg: 'rgba(139, 92, 246, 0.1)', border: 'rgba(139, 92, 246, 0.25)' };
    case 'NRP + SMS': 
      return { color: '#db2777', bg: 'rgba(236, 72, 153, 0.1)', border: 'rgba(236, 72, 153, 0.25)' };
    case 'NRP + WhatsApp': 
      return { color: '#0d9488', bg: 'rgba(20, 184, 166, 0.1)', border: 'rgba(20, 184, 166, 0.25)' };
    default: 
      return { color: '#64748b', bg: 'rgba(100, 116, 139, 0.08)', border: 'rgba(100, 116, 139, 0.18)' };
  }
};

const CellPill = ({ label, color, bg, border, mono }) => (
  <Box
    component="span"
    sx={{
      display: 'inline-flex', alignItems: 'center', px: 1, py: 0.4, borderRadius: '8px',
      backgroundColor: bg, color, border: '1px solid', borderColor: border,
      fontSize: '0.7rem', fontWeight: 700, lineHeight: 1.2,
      fontFamily: mono ? '"Roboto Mono", monospace' : 'inherit',
    }}
  >
    {label}
  </Box>
);

const SessionCustomerListTable = (props) => {
  const {
    customersFixed,
    sessionId,
    customersList,
    session,
    formation,
    sources,
    relanceFixed,
    formations,
    getSession,
    setShowCheckUserDataAlert,
    ...other
  } = props;
  const [customers, setCustomers] = useState([]);
  const [relance, setRelance] = useState([]);
  const [rows, setRows] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [exporting, setExporting] = useState(false);
  const [show, setShow] = useState(false);
  const [showDec, setShowDec] = useState(false);
  const [currentIdDec, setCurrentIdDec] = useState(0);
  const { user } = useAuth();
  const theme = useTheme();
  // const [showAlert, setShowAlert] = useState(false);
  // const [alertMessage, setAlertMessage] = useState('');
  const [indexFormationDec, setIndexFormationDec] = useState(0);
  const [disableChoiceSession, setDisableChoiceSession] = useState(true);
  let sessionDec = 0;
  const [valueIdSession, setValueIdSession] = useState(false);
  const [openDialogDelete, setOpenDialogDelete] = useState(false);
  const [openCommonDialog, setOpenCommonDialog] = useState(false);
  const [customerName, setCustomerName] = useState("");
  const [dialogText, setDialogText] = useState("");
  const [dialogAction, setDialogAction] = useState("");
  // Dialogue de choix d'attestation (formation « certificat de décès », prog. 520260720012)
  const [openCertChoice, setOpenCertChoice] = useState(false);
  const [certChoiceRow, setCertChoiceRow] = useState(null);
  // Moteur de signature choisi pour l'envoi d'une convention : 'internal' (SES) | 'ilovepdf'
  const [selectedEngine, setSelectedEngine] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [customerToDeleteId, setCustomerToDeleteId] = useState(null);
  const [currentRowLearnerSessionId, setCurrentRowLearnerSessionId] =
    useState(null);
  const [openTooltip, setOpenTooltip] = useState(false);
  const [showEmails, setShowEmails] = useState(false);
  const [showSessionEmailDialog, setShowSessionEmailDialog] = useState(false);
  const [progress, setProgress] = useState(0);
  const [buffer, setBuffer] = useState(10);
  const progressRef = useRef(() => {});
  const [selectedRows, setSelectedRows] = useState([]);
  const [financiers, setFinanciers] = useState([]);
  // Décalage Stepper states
  const [activeDecalageStep, setActiveDecalageStep] = useState(0);
  const [selectedExistingFormation, setSelectedExistingFormation] = useState(null);
  const [existingEnrolledFormations, setExistingEnrolledFormations] = useState([]);
  const [loadingExistingEnrolled, setLoadingExistingEnrolled] = useState(false);
  const [currentCustomerIdForDecalage, setCurrentCustomerIdForDecalage] = useState(null);
  const [sessionDecState, setSessionDecState] = useState(null);
  const [customerSearchOptions, setCustomerSearchOptions] = useState([]);
  const [isSearchingCustomers, setIsSearchingCustomers] = useState(false);
  const [customerSearchQuery, setCustomerSearchQuery] = useState("");

  useEffect(() => {
    let active = true;

    if (customerSearchQuery.length < 3) {
      setCustomerSearchOptions([]);
      return undefined;
    }

    setIsSearchingCustomers(true);

    const timer = setTimeout(async () => {
      try {
        const response = await sessionApi.searchCustomers(
          customerSearchQuery,
          localStorage.getItem("accessToken")
        );

        if (active) {
          if (response.status) {
            setCustomerSearchOptions(response.data);
          }
        }
      } catch (error) {
        console.error("Error searching customers:", error);
      } finally {
        if (active) {
          setIsSearchingCustomers(false);
        }
      }
    }, 500);

    return () => {
      active = false;
      clearTimeout(timer);
    };
  }, [customerSearchQuery]);

  // useEffect(() => {
  //   progressRef.current = () => {
  //     if (progress > 100) {
  //       setProgress(0);
  //       setBuffer(10);
  //     } else {
  //       const diff = Math.random() * 10;
  //       const diff2 = Math.random() * 10;
  //       setProgress(progress + diff);
  //       setBuffer(progress + diff + diff2);
  //     }
  //   };
  // });

  // useEffect(() => {
  //   const timer = setInterval(() => {
  //     progressRef.current();
  //   }, 500);

  //   return () => {
  //     clearInterval(timer);
  //   };
  // }, []);

  const downloadAgrement = async (id) => {
    try {
      setIsLoading(true);
      const response = await customerApi.downloadAgrement(
        id,
        localStorage.getItem("accessToken")
      );
      if (response.status === 500) {
        toast.error(
          "Une erreur est survenue lors du téléchargement de la convention !"
        );
      } else if (response.status === 400) {
        toast.error(response.errorMessage);
      } else {
        toast.success("Téléchargement effectué avec succès !");
        getSession();
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
      setIsLoading(false);
      toast.error("Une erreur est survenue lors du téléchargement !");
    }
  };

  const downloadMultipleAgreements = async () => {
    try {
      setIsLoading(true);
      const selectedRowsIDs = selectedRows.map((row) => row.id);
      const response = await customerApi.downloadMultipleAgreements(
        selectedRowsIDs,
        sessionId,
        localStorage.getItem("accessToken")
      );
      console.clear();
      if (response.some((res) => res.status === "error")) {
        toast.error(
          "Une ou plusieurs conventions n'ont pas pu être téléchargées. Veuillez vérifier que toutes informations nécessaires au téléchargement sont bien renseignées !"
        );
      } else {
        toast.success("Téléchargement effectué avec succès !");
        // getSession();
        // setSelectedRows([]);
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
      setIsLoading(false);
      toast.error("Une erreur est survenue lors du téléchargement !");
    }
  };

  const downloadMultipleCertificatesToPdf = async () => {
    try {
      setIsLoading(true);
      const selectedRowsIDs = selectedRows.map((row) => row.id);
      const response = await customerApi.downloadMultipleCertificatesToPdf(
        selectedRowsIDs,
        sessionId,
        localStorage.getItem("accessToken")
      );
      console.clear();
      if (response.some((res) => res.status === "error")) {
        toast.error(
          "Une ou plusieurs conventions n'ont pas pu être téléchargées. Veuillez vérifier que toutes informations nécessaires au téléchargement sont bien renseignées !"
        );
      } else {
        toast.success("Téléchargement effectué avec succès !");
        // getSession();
        // setSelectedRows([]);
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
      setIsLoading(false);
      toast.error("Une erreur est survenue lors du téléchargement !");
    }
  };

  const downloadCertificate = async (id) => {
    try {
      setIsLoading(true);
      const response = await customerApi.downloadCertificate(
        id,
        localStorage.getItem("accessToken")
      );
      if (response.status === 500) {
        toast.error(
          "Une erreur est survenue lors du téléchargemen de l'attestation !"
        );
      } else if (response.status === 400) {
        toast.error(response.errorMessage);
      } else {
        toast.success("Téléchargement effectué avec succès !");
        getSession();
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
      setIsLoading(false);
      toast.error("Une erreur est survenue lors du téléchargement !");
    }
  };

  const downloadCertificateToPdf = async (id) => {
    try {
      setIsLoading(true);
      const response = await customerApi.downloadCertificateToPdf(
        id,
        localStorage.getItem("accessToken")
      );
      if (response.status === 500) {
        toast.error(
          "Une erreur est survenue lors du téléchargemen de l'attestation !"
        );
      } else if (response.status === 400) {
        toast.error(response.errorMessage);
      } else {
        toast.success("Téléchargement effectué avec succès !");
        getSession();
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
      setIsLoading(false);
      toast.error("Une erreur est survenue lors du téléchargement !");
    }
  };

  const downloadMultipleCertificates = async () => {
    try {
      setIsLoading(true);
      const selectedRowsIDs = selectedRows.map((row) => row.id);
      const response = await customerApi.downloadMultipleCertificates(
        selectedRowsIDs,
        sessionId,
        localStorage.getItem("accessToken")
      );
      console.clear();
      if (response.some((res) => res.status === "error")) {
        toast.error(
          "Une ou plusieurs certificats n'ont pas pu être téléchargés. Veuillez vérifier que toutes informations nécessaires au téléchargement sont bien renseignées !"
        );
      } else {
        toast.success("Téléchargement effectué avec succès !");
        // getSession();
        // setSelectedRows([]);
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
      setIsLoading(false);
      toast.error("Une erreur est survenue lors du téléchargement !");
    }
  };

  const downloadSwarnStatement = async (id) => {
    try {
      setIsLoading(true);
      const response = await customerApi.downloadSwarnStatement(
        id,
        localStorage.getItem("accessToken")
      );
      if (response.status === 500) {
        toast.error(
          "Une erreur est survenue lors du téléchargemen de l'attestation !"
        );
      } else if (response.status === 400) {
        toast.error(response.errorMessage);
      } else {
        toast.success("Téléchargement effectué avec succès !");
        getSession();
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
      setIsLoading(false);
      toast.error("Une erreur est survenue lors du téléchargement !");
    }
  };

  const downloadMultipleSwarnStatements = async () => {
    try {
      setIsLoading(true);
      const selectedRowsIDs = selectedRows.map((row) => row.id);
      const response = await customerApi.downloadMultipleSwarnStatements(
        selectedRowsIDs,
        sessionId,
        localStorage.getItem("accessToken")
      );
      console.clear();
      if (response.some((res) => res.status === "error")) {
        toast.error(
          "Une ou plusieurs attestations n'ont pas pu être téléchargées. Veuillez vérifier que toutes informations nécessaires au téléchargement sont bien renseignées !"
        );
      } else {
        toast.success("Téléchargement effectué avec succès !");
        // getSession();
        // setSelectedRows([]);
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
      setIsLoading(false);
      toast.error("Une erreur est survenue lors du téléchargement !");
    }
  };

  const sendEmails = async (type) => {
    try {
      setIsLoading(true);
      const response = await sessionApi.sendEmails(
      selectedRows.map((row) => row.id),
      type,
        localStorage.getItem("accessToken")
      );
      if (response.status === 500) {
        toast.error(
          "Une erreur est survenue lors de l'envoi des mails !"
        );
      } else if (response.status === 400) {
        toast.error(response.errorMessage);
      } else {
        toast.success("Emails envoyés avec succès !");
      }
      setIsLoading(false);
      setShowEmails(false);
    } catch (err) {
      console.error(err);
      setShowEmails(false);
      setIsLoading(false);
      toast.error("Une erreur est survenue lors de l'envoi des mails !");
    }
  };

  const sendAgreement = async (id, engine) => {
    try {
      setIsLoading(true);
      const response = await customerApi.sendAgreement(
        id,
        localStorage.getItem("accessToken"),
        engine
      );
      if (response.status === 500) {
        toast.error(
          "Une erreur est survenue lors de l'envoi de la convention !"
        );
      } else if (response.status === 400) {
        toast.error(response.errorMessage);
      } else {
        toast.success("Convention de formation envoyée avec succès !");
        getSession();
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.error(err);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
      setIsLoading(false);
      toast.error("Une erreur est survenue lors de l'envoi de la convention !");
    }
  };

  const sendCertificate = async (id) => {
    try {
      setIsLoading(true);
      const response = await customerApi.sendCertificate(
        id,
        localStorage.getItem("accessToken")
      );
      if (response.status === 500) {
        toast.error(
          "Une erreur est survenue lors de l'envoi de l'attestation !"
        );
      } else if (response.status === 400) {
        toast.error(response.errorMessage);
      } else {
        toast.success("Attestation de fin de formation envoyée avec succès !");
        getSession();
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      toast.error("Une erreur est survenue lors de l'envoi de l'attestation !");
      setIsLoading(false);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
    }
  };

  // Attestation « certificat de décès » (template Attestation.docx, apteed).
  // Pour les autres tenants, le back renvoie 400 « Attestation introuvable ».
  const sendDeathCertificate = async (id) => {
    try {
      setIsLoading(true);
      const response = await customerApi.sendDeathCertificate(
        id,
        localStorage.getItem("accessToken")
      );
      if (response.status === 500) {
        toast.error("Une erreur est survenue lors de l'envoi de l'attestation !");
      } else if (response.status === 400) {
        toast.error(response.errorMessage || "Attestation introuvable");
      } else {
        toast.success("Attestation certificat de décès envoyée avec succès !");
        getSession();
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.error(err);
      toast.error("Une erreur est survenue lors de l'envoi de l'attestation !");
      setIsLoading(false);
      setOpenCommonDialog(false);
    }
  };

  const sendSwarnStatement = async (id) => {
    try {
      setIsLoading(true);
      const response = await customerApi.sendSwarnStatement(
        id,
        localStorage.getItem("accessToken")
      );
      console.clear();
      if (response.status === 500) {
        toast.error(
          "Une erreur est survenue lors de l'envoi de l'attestation !"
        );
      } else if (response.status === 400) {
        toast.error(response.errorMessage);
      } else {
        toast.success("Attestation sur l'honneur envoyée avec succès !");
        getSession();
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      toast.error("Une erreur est survenue lors de l'envoi de l'attestation !");
      setIsLoading(false);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
    }
  };

  const sendMultipleAgreements = async (engine) => {
    try {
      setIsLoading(true);
      const selectedRowsIDs = selectedRows.map((row) => row.id);
      const response = await customerApi.sendMultipleAgreements(
        selectedRowsIDs,
        localStorage.getItem("accessToken"),
        engine
      );
      console.clear();
      if (response.status === 500) {
        toast.error(
          "Une erreur est survenue lors de l'envoi des conventions !"
        );
      } else if (response.status === 400) {
        toast.error(response.errorMessage);
      } else {
        toast.success("Les conventions ont été envoyées avec succès !");
        getSession();
        setSelectedRows([]);
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      toast.error("Une erreur est survenue lors de l'envoi des conventions !");
      setIsLoading(false);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
    }
  };

  const sendMultipleSwarnStatements = async () => {
    try {
      setIsLoading(true);
      const selectedRowsIDs = selectedRows.map((row) => row.id);
      const response = await customerApi.sendMultipleSwarnStatements(
        selectedRowsIDs,
        localStorage.getItem("accessToken")
      );
      console.clear();
      if (response.status === 500) {
        toast.error(
          "Une erreur est survenue lors de l'envoi des attestations !"
        );
      } else if (response.status === 400) {
        toast.error(response.errorMessage);
      } else {
        toast.success(
          "Les attestations sur honneur ont été envoyées avec succès !"
        );
        getSession();
        setSelectedRows([]);
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      toast.error("Une erreur est survenue lors de l'envoi des attestations !");
      setIsLoading(false);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
    }
  };

  const sendMultipleCertificates = async () => {
    try {
      setIsLoading(true);
      const selectedRowsIDs = selectedRows.map((row) => row.id);
      const response = await customerApi.sendMultipleCertificates(
        selectedRowsIDs,
        localStorage.getItem("accessToken")
      );
      console.clear();
      if (response.some((res) => res.status === "error")) {
        toast.error(
          "Une erreur est survenue lors de l'envoi des certificats de réuissites !"
        );
      } else {
        toast.success(
          "Les certificats de réuissites ont envoyés avec succès !"
        );
        getSession();
        setSelectedRows([]);
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      toast.error("Une erreur est survenue lors de l'envoi de l'attestation !");
      setIsLoading(false);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
    }
  };

  // Envoi de l'attestation FIF-PL (APR) aux apprenants sélectionnés en financeur FIFPL-PAIEMENT (id 4)
  const sendMultipleFifplCertificates = async () => {
    try {
      setIsLoading(true);
      const selectedRowsIDs = selectedRows
        .filter((row) => row.financier_id === 4)
        .map((row) => row.id);
      if (selectedRowsIDs.length === 0) {
        toast.error("Aucun apprenant en financeur FIFPL-PAIEMENT sélectionné.");
        setIsLoading(false);
        setOpenCommonDialog(false);
        return;
      }
      const response = await customerApi.sendMultipleFifplCertificates(
        selectedRowsIDs,
        localStorage.getItem("accessToken")
      );
      console.clear();
      if (response.some((res) => res.status === "error")) {
        toast.error(
          "Une erreur est survenue lors de l'envoi des attestations FIF-PL !"
        );
      } else {
        toast.success("Les attestations FIF-PL ont été envoyées avec succès !");
        getSession();
        setSelectedRows([]);
      }
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      toast.error(
        "Une erreur est survenue lors de l'envoi des attestations FIF-PL !"
      );
      setIsLoading(false);
      setOpenCommonDialog(false);
      setShowCheckUserDataAlert(true);
    }
  };

  // eslint-disable-next-line consistent-return
  const hasCompletedProfile = (row) => {
    if (
      row.adeli_rpps === "" ||
      row.email === "" ||
      row.firstname === "" ||
      row.lastname === "" ||
      row.profession === "" ||
      row.civilite === "" ||
      row.adress === "" ||
      row.city === "" ||
      row.zip === ""
    ) {
      return false;
    }
    return true;
  };

  const getCertificateSentStatus = (certificate_sent) => {
    return certificate_sent ? "primary" : "secondary";
  };

  const getConventionSentStatus = (agreement_sent, agreement_completed) => {
    return agreement_sent
      ? agreement_completed
        ? "primary"
        : "warning"
      : "secondary";
  };

  const getAttestationSentStatus = (honor_sent, honor_completed) => {
    return honor_sent ? (honor_completed ? "primary" : "warning") : "secondary";
  };

  const downloadSignedFileByTokenRequester = async (token_requester) => {
    try {
      setIsLoading(true);
      console.clear();
      const response = await sessionApi.downloadSignedFileByTokenRequester(
        token_requester,
        localStorage.getItem("accessToken")
      );
      if (response.status === 500) {
        toast.error(
          "Une erreur est survenue lors serveur est survenue lors du téléchargement ! Veuillez réessayer plus tard !"
        );
      } else if (response.status === 400) {
        toast.error(
          "Une erreur est survenue lors du téléchargement ! Vérifiez que vous êtes authentifiez puis réessayez !"
        );
      } else if (response.status === 401) {
        toast.error(
          "Une erreur est survenue lors du téléchargement ! Adressez vous à votre administrateur pour en savoir plus !"
        );
      } else if (response.status === 404) {
        toast.error(
          "Une erreur est survenue lors du téléchargement ! Le fichier que vous essayez de télécharger n'existe plus ou a pu être déplacé !"
        );
      } else {
        toast.success("Téléchargement effectué avec succès !");
        getSession();
      }
      getSession();
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      toast.error(
        "Une erreur est survenue lors du téléchargement ! Veuillez réessayer plus tard !"
      );
      setIsLoading(false);
      setOpenCommonDialog(false);
    }
  };

  const handleUpdateAttestationsAndConventionsCompletionState = async () => {
    try {
      setIsLoading(true);
      const response =
        await sessionApi.handleUpdateAttestationsAndConventionsCompletionState(
          localStorage.getItem("accessToken")
        );
      toast.success("Mise à jour des données effectuées avec succès !");
      getSession();
      setIsLoading(false);
      setOpenCommonDialog(false);
    } catch (err) {
      console.clear();
      console.error(err);
      toast.error(
        "Une erreur est survenue lors de la mise à jour des données !"
      );
      setIsLoading(false);
      setOpenCommonDialog(false);
    }
  };

  const CustomToolbar = () =>
    (user.id_service === 0 ? (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport />
        <GridToolbarQuickFilter />
      </GridToolbarContainer>
    ) : (
      <GridToolbarContainer>
        <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarDensitySelector />
      </GridToolbarContainer>
    ));

  const filterOptions = createFilterOptions({
    limit: 100,
    stringify: (option) =>
      `${option.email} ${option.firstname} ${option.lastname}`,
  });

  const handleShow = () => {
    setShow(!show);
  };

  // Styles d'actions modernes (barre au-dessus de la grille)
  const primaryBtnSx = {
    m: 1,
    borderRadius: '12px',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.84rem',
    color: '#475569',
    border: '1px solid rgba(100, 116, 139, 0.18)',
    backgroundColor: 'rgba(100, 116, 139, 0.07)',
    px: 2.5,
    py: 1,
    '&:hover': { backgroundColor: 'rgba(100, 116, 139, 0.13)', borderColor: 'rgba(100, 116, 139, 0.3)', transform: 'translateY(-1px)' },
    '&.Mui-disabled': { color: 'rgba(100,116,139,0.45)', borderColor: 'rgba(100,116,139,0.12)', backgroundColor: 'rgba(100,116,139,0.04)' },
    transition: 'all 0.2s ease-in-out',
  };
  const actionBtnSx = {
    m: 1,
    borderRadius: '12px',
    textTransform: 'none',
    fontWeight: 600,
    fontSize: '0.82rem',
    color: '#475569',
    border: '1px solid rgba(100, 116, 139, 0.18)',
    backgroundColor: 'rgba(100, 116, 139, 0.07)',
    px: 2,
    py: 0.9,
    '&:hover': { backgroundColor: 'rgba(100, 116, 139, 0.13)', borderColor: 'rgba(100, 116, 139, 0.3)', transform: 'translateY(-1px)' },
    '&.Mui-disabled': { color: 'rgba(100,116,139,0.45)', borderColor: 'rgba(100,116,139,0.12)', backgroundColor: 'rgba(100,116,139,0.04)' },
    transition: 'all 0.2s ease-in-out',
  };

  const handleCloseDialog = () => {
    // setShowAlert(false);
    setShowDec(false);
  };

  useEffect(() => {
    setRows(
      customers.map((customer) => ({
        id: customer.id,
        customers_id: customer.customers_id,
        firstname: customer.customerFirstname,
        lastname: customer.customerLastname,
        status: customer.status,
        primary_connection:
          customer.primary_connection !== null
            ? moment(customer.primary_connection).format("DD/MM/YYYY HH:mm:ss")
            : "",
        last_connection:
          customer.last_connection !== null
            ? moment(customer.last_connection).format("DD/MM/YYYY HH:mm:ss")
            : "",
        progression: customer.progression,
        duration: customer.duration,
        real_price: customer.real_price,
        financier_id: customer.financier_id || 0,
        program_number: customer.program_number,
        source_id: customer.source_id,
        email: customer.email,
        phone: customer.phone,
        adeli_rpps: customer.adeli_rpps,
        profession: customer.profession,
        decalages: customer.decalages,
        invoiced: customer.invoiced,
        agreement_sent: customer.agreement_sent,
        agreement_completed: customer.agreement_completed,
        agreement_completed_url: customer.agreement_completed_url,
        agreement_token_requester: customer.agreement_token_requester,
        honor_token_requester: customer.honor_token_requester,
        honor_sent: customer.honor_sent,
        honor_completed: customer.honor_completed,
        honor_completed_url: customer.honor_completed_url,
        certificate_sent: customer.certificate_sent,
        subscribed_at:
          customer.subscribed_at !== null
            ? moment(customer.subscribed_at).format("DD/MM/YYYY HH:mm:ss")
            : "",
        comments: customer.comments,
        comments_logistique: customer.comments_logistique,
        qualification: customer.qualification,
        not_relaunch: customer.not_relaunch,
        step: customer.step,
        tlms_percentage: customer.tlms_percentage,
        presence: customer.presence,
        totalProgress: customer.totalProgress,
      }))
    );
  }, [customers]);

  useEffect(() => {
    setCustomers(customersFixed);
    setRelance(
      relanceFixed.map((rel) =>
        (rel[0] === undefined
          ? [
              {
                id: 0,
                customers_id: 0,
                status: null,
                date: null,
                primary_connection: null,
                last_connection: null,
                real_price: null,
              },
            ]
          : rel)
      )
    ); // On enlève les valeurs vide du tableau des historique de relance
  }, [customersFixed]);

  // Charger la liste des financeurs
  useEffect(() => {
    const loadFinanciers = async () => {
      try {
        const response = await formationApi.getFinanciers(localStorage.getItem("accessToken"));
        if (response.status === 200) {
          setFinanciers(response.data);
        }
      } catch (err) {
        console.error("Erreur lors du chargement des financeurs:", err);
        // En cas d'erreur, utiliser une liste par défaut
        setFinanciers([
          { id: 1, name: "DPC" },
          { id: 5, name: "OPCO-EP" },
          { id: 6, name: "FAFPM" },
          { id: 7, name: "FIFPL-PCC" },
          { id: 4, name: "FIFPL-PAIEMENT" }
        ]);
      }
    };
    loadFinanciers();
  }, []);

  const handleDelete = async (id) => {
    try {
      setIsLoading(true);
      await sessionApi.deleteCustomer(id, localStorage.getItem("accessToken"));
      toast.success("Apprenant supprimé !");
      const tempCustomers = [...customers];
      tempCustomers.splice(
        tempCustomers.findIndex((customer) => customer.id === id),
        1
      );
      setCustomers(tempCustomers);
      setRows((prevRows) => prevRows.filter((row) => row.id !== id));
      setIsLoading(false);
      setOpenDialogDelete(false);
    } catch (err) {
      console.error(err);
      toast.error("Il y a eu un souci lors de la suppression !");
    }
  };

  const handleChange = async (params) => {
    // if (params.field === 'presence' || params.field === 'progression' || params.field === 'tlms_percentage') {
    //   // rows[0][params.field] = params.value;
    //   const row = rows.find((rowSession) => rowSession.id === params.id);
    // }
    if (
      params.field === "primary_connection" ||
      params.field === "last_connection" ||
      params.field === "subscribed_at"
    ) {
      params.value = moment(params.value).format("YYYY-MM-DD HH:mm:ss");
    }
    if (params.field === "real_price") {
      params.value = parseFloat(params.value).toFixed(3);
    }
    if (params.field === "invoiced") {
      params.value = params.value === true ? 1 : false;
    }
    if (params.field === "presence") {
      params.value = params.value === true ? 1 : false;
    }
    if (params.field === "financier_id") {
      params.value = parseInt(params.value, 10);
    }

    if (params.value === "Décalé") {
      // On met la modale du choix de la session décalée à true
      setShowDec(true);
      setCurrentIdDec(params.id);
      const row = rows.find((r) => r.id === params.id);
      if (row) {
        setCurrentCustomerIdForDecalage(row.customers_id);
      }
      setActiveDecalageStep(0);
      setSelectedExistingFormation(null);
      setSessionDecState(null);
    } else {
      try {
        await sessionApi.editCustomer(
          2,
          params.id,
          params.value,
          localStorage.getItem("accessToken"),
          params.field
        );
        setCustomers((prevCustomers) =>
          prevCustomers.map((c) =>
            c.id === params.id ? { ...c, [params.field]: params.value } : c
          )
        );
        setRows((prevRows) =>
          prevRows.map((r) =>
            r.id === params.id ? { ...r, [params.field]: params.value } : r
          )
        );
      } catch (err) {
        console.error(err);
        toast.error("Il y a eu un souci lors de la modification !");
      }
    }
  };

  const handleDecalage = async () => {
    try {
      await sessionApi.decalage(
        currentIdDec,
        sessionDecState ?? sessionDec,
        localStorage.getItem("accessToken")
      );
      toast.success("Apprenant décalé !");
      handleCloseDialog();
      if (typeof getSession === 'function') {
        getSession();
      }
    } catch (err) {
      console.error(err);
      toast.error("Il y a eu un souci lors de la modification !");
    }
  };

  const handleDecalageFromStatus = async (learnerSessionId, targetSessionId) => {
    try {
      if (!learnerSessionId || !targetSessionId) return;
      await sessionApi.decalageFromStatus(
        learnerSessionId,
        targetSessionId,
        localStorage.getItem('accessToken')
      );
      toast.success('Apprenant décalé !');
      setSelectedExistingFormation(null);
      handleCloseDialog();
      if (typeof getSession === 'function') {
        getSession();
      }
    } catch (err) {
      console.error(err);
      toast.error("Il y a eu un souci lors de la modification !");
    }
  };

  // Charger les formations où l'apprenant est déjà inscrit pour l'année en cours
  useEffect(() => {
    const loadExistingEnrolled = async () => {
      if (!showDec || !currentCustomerIdForDecalage) return;
      setLoadingExistingEnrolled(true);
      try {
        const data = await customerApi.getCustomer(
          currentCustomerIdForDecalage,
          localStorage.getItem("accessToken")
        );
        const currentYear = moment().year();
        const enrolled = Array.isArray(data.formations)
          ? data.formations.filter(
              (f) => f.status === "Inscrit" && moment(f.end_date).year() >= currentYear && f.session_id !== parseInt(sessionId)
            )
          : [];
          console.log(enrolled);
          console.log(sessionId);
        setExistingEnrolledFormations(enrolled);
      } catch (e) {
        setExistingEnrolledFormations([]);
      } finally {
        setLoadingExistingEnrolled(false);
      }
    };
    loadExistingEnrolled();
  }, [showDec, currentCustomerIdForDecalage]);

  // téléchargement de la liste de présence (PDF) pour les présentielle / virtuelle
  const handleDowloadAttendanceList = async () => {
    try {
      await customerApi.handleDownloadAttendanceListPdf(
        sessionId,
        localStorage.getItem("accessToken")
      );
      toast.success("Téléchargement éffectué avec succès !");
    } catch (err) {
      console.error(err);
      toast.error("Une erreur est survenue lors du téléchargement !");
    }
  };

  const handleExportPlateforme = async () => {
    try {
      setExporting(true);
      await sessionApi.subscribeNotLearners(
        sessionId,
        localStorage.getItem("accessToken")
      );
      setExporting(false);
    } catch (err) {
      console.error(err);
      toast.error("Il y a eu un souci lors de l'exportation !");
      setExporting(false);
    }
  };

  // const handleGetAttestationsDPC = async () => {
  //   try {
  //     const data = await sessionApi.getAttestationsDPC(sessionId, localStorage.getItem('accessToken'));
  //     const merger = new PDFMerger();

  //     await Promise.all(data.data.apprenants.map(async (customer) => {
  //       const element = await pdf(
  //         <AttestationPDF
  //           customer={customer}
  //           formation={data.data.formation}
  //           orientations={data.data.orientations}
  //         />
  //       ).toBlob();
  //       await merger.add(element);
  //     }));

  //     const mergedPdf = await merger.saveAsBlob();

  //     const fileURL = URL.createObjectURL(mergedPdf);
  //     window.open(fileURL, '_blank');
  //   } catch (err) {
  //     console.error(err);
  //     toast.error('Il y a eu un souci lors de la génération des documents !');
  //   }
  // };

  const columnsFinal = [
    {
      field: "lastname",
      headerName: "Apprenant",
      renderCell: (cellValues) => (
        <Tooltip
          followCursor
          enterDelay={500}
          placement="top"
          title={
            <span style={{ whiteSpace: "pre-line" }}>
              Email: {cellValues.row.email}
              {"\n"}
              RPPS: {cellValues.row.adeli_rpps}
              {"\n"}
              Profession: {cellValues.row.profession}
              {"\n"}
              {/* Inscription:
              {' '}
              {cellValues.row.subscribed_at !== null ? moment(cellValues.row.subscribed_at).format('DD/MM/YYYY HH:mm:ss') : ''} */}
              1ère connexion: {cellValues.row.primary_connection}
              {"\n"}
              Dernière connexion: {cellValues.row.last_connection}
            </span>
          }
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, py: 0.5, minWidth: 0 }}>
            {(() => {
              const grad = LEARNER_AVATAR_GRADIENTS[hashStr(`${cellValues.row.firstname}${cellValues.row.lastname}`) % LEARNER_AVATAR_GRADIENTS.length];
              return (
                <Avatar
                  sx={{
                    width: 38, height: 38, borderRadius: '11px', flexShrink: 0,
                    fontSize: '0.78rem', fontWeight: 800, color: '#fff',
                    background: `linear-gradient(135deg, ${grad[0]} 0%, ${grad[1]} 100%)`,
                    boxShadow: `0 4px 12px ${grad[0]}40`,
                  }}
                >
                  {initialsOf(cellValues.row.firstname, cellValues.row.lastname)}
                </Avatar>
              );
            })()}
            <Link
              component={RouterLink}
              to={`/dashboard/customers/${cellValues.row.customers_id}`}
              sx={{
                textDecoration: 'none', fontWeight: 700, fontSize: '0.83rem', color: 'text.primary',
                lineHeight: 1.3, transition: 'color 0.15s', minWidth: 0,
                display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical',
                overflow: 'hidden', textOverflow: 'ellipsis', wordBreak: 'break-word',
                '&:hover': { color: '#3b82f6' },
              }}
            >
              {cellValues.row.firstname} {cellValues.row.lastname}
            </Link>
          </Box>
        </Tooltip>
      ),
      width: 360,
    },
    {
      field: "contact",
      headerName: "Contact",
      width: 250,
      renderCell: (cellValues) => (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, py: 0.5 }}>
          <Typography sx={{ fontSize: '0.8rem', fontWeight: 600, color: 'text.primary' }}>
            {cellValues.row.email || '—'}
          </Typography>
          {cellValues.row.phone && (
            <Typography sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
              {cellValues.row.phone}
            </Typography>
          )}
        </Box>
      ),
    },
    {
      field: "adeli_rpps",
      headerName: "RPPS",
      width: 130,
      renderCell: (cellValues) => (cellValues.row.adeli_rpps
        ? <CellPill label={cellValues.row.adeli_rpps} color="#475569" bg="rgba(100, 116, 139, 0.07)" border="rgba(100, 116, 139, 0.16)" mono />
        : <Typography sx={{ fontSize: '0.78rem', color: 'text.disabled' }}>—</Typography>),
    },
    {
      field: "status",
      headerName: "Statut",
      type: "singleSelect",
      renderCell: (cellValues) => {
        let statut = "";
        const sStyle = getLearnerStatusStyle(cellValues.row.status);
        if (cellValues.row.status === "Inscrit") {
          statut = <CellPill label={cellValues.row.status} color={sStyle.color} bg={sStyle.bg} border={sStyle.border} />;
        } else if (
          cellValues.row.status === "En attente" ||
          cellValues.row.status === "À transférer"
        ) {
          statut = <CellPill label={cellValues.row.status} color={sStyle.color} bg={sStyle.bg} border={sStyle.border} />;
        } else if (cellValues.row.status === "InscritD") {
          statut = (
            <Tooltip
              followCursor
              enterDelay={500}
              color="inscritD"
              placement="top"
              title={
                cellValues.row.decalages !== undefined
                  ? cellValues.row.decalages.map((dec) => (
                      <span style={{ whiteSpace: "pre-line" }}>
                        {`${dec.name} session: ${dec.number_session}`}
                        {"\n"}
                      </span>
                    ))
                  : null
              }
            >
              <span>
                <CellPill label={cellValues.row.status} color={sStyle.color} bg={sStyle.bg} border={sStyle.border} />
              </span>
            </Tooltip>
          );
        } else if (cellValues.row.status === "Décalé") {
          statut = (
            <Tooltip
              followCursor
              enterDelay={500}
              placement="top"
              title={
                cellValues.row.decalages !== undefined
                  ? cellValues.row.decalages.map((dec) => (
                      <span style={{ whiteSpace: "pre-line" }}>
                        {`${dec.name} session: ${dec.number_session}`}
                        {"\n"}
                      </span>
                    ))
                  : null
              }
            >
              <span>
                <CellPill label={cellValues.row.status} color={sStyle.color} bg={sStyle.bg} border={sStyle.border} />
              </span>
            </Tooltip>
          );
        } else if (
          cellValues.row.status === "- de 5 personnes" ||
          cellValues.row.status === "Annulation" ||
          cellValues.row.status === "À décaler" ||
          cellValues.row.status === "Désinscrit"
        ) {
          statut = <CellPill label={cellValues.row.status} color={sStyle.color} bg={sStyle.bg} border={sStyle.border} />;
        }
        // if (cellValues.row.status === 'Inscrit') {
        //   statut = (
        //     <Chip
        //       label={cellValues.row.status}
        //       variant="outlined"
        //       color="success"
        //       size="small"
        //       disabled={user.id_service === 4}
        //     />
        //   );
        // } else if (cellValues.row.status === 'En attente' || cellValues.row.status === 'À transférer') {
        //   statut = (
        //     <Chip
        //       label={cellValues.row.status}
        //       variant="outlined"
        //       color="warning"
        //       size="small"
        //       disabled={user.id_service === 4}
        //     />
        //   );
        // } else if (cellValues.row.status === 'InscritD') {
        //   statut = (
        //     <Tooltip
        //       followCursor
        //       enterDelay={500}
        //       color="inscritD"
        //       placement="top"
        //       title={cellValues.row.decalages !== undefined ? cellValues.row.decalages.map((dec) => (
        //         <span style={{ whiteSpace: 'pre-line' }}>
        //           {`${dec.name} session: ${dec.number_session}`}
        //           {'\n'}
        //         </span>
        //       )) : null}
        //     >
        //       <Chip
        //         label={cellValues.row.status}
        //         variant="outlined"
        //         color="inscritD"
        //         size="small"
        //         disabled={user.id_service === 4}
        //       />
        //     </Tooltip>
        //   );
        // } else if (cellValues.row.status === 'Décalé') {
        //   statut = (
        //     <Tooltip
        //       followCursor
        //       enterDelay={500}
        //       placement="top"
        //       title={cellValues.row.decalages !== undefined ? cellValues.row.decalages.map((dec) => (
        //         <span style={{ whiteSpace: 'pre-line' }}>
        //           {`${dec.name} session: ${dec.number_session}`}
        //           {'\n'}
        //         </span>
        //       )) : null}
        //     >
        //       <Chip
        //       label={cellValues.row.status}
        //       variant="outlined"
        //       color="secondary"
        //       size="small"
        //       disabled={user.id_service === 4}
        //     />
        //     </Tooltip>
        //   );
        // } else if (cellValues.row.status === '- de 5 personnes' || cellValues.row.status === 'Annulation' || cellValues.row.status === 'À décaler') {
        //   statut = (
        //     <Chip
        //       label={cellValues.row.status}
        //       variant="outlined"
        //       color="error"
        //       size="small"
        //       disabled={user.id_service === 4}
        //     />
        //   );
        // }
        return statut;
      },
      editable: true,
      valueOptions: [
        "Inscrit",
        "En attente",
        "À décaler",
        "Décalé",
        "- de 5 personnes",
        "Annulation",
        "À transférer",
        "Désinscrit",
      ],
      width: 150,
    },
    {
      field: "subscribed_at",
      headerName: "Date d'inscription",
      type: "dateTime",
      width: 160,
      editable: [0, 4].includes(user.id_service),
    },
    // {
    //   field: 'primary_connection',
    //   headerName: 'Première connexion',
    //   editable: user.access_level === 0,
    //   type: 'dateTime',
    //   width: 160,
    // },
    // {
    //   field: 'last_connection',
    //   headerName: 'Dernière connexion',
    //   type: 'dateTime',
    //   editable: user.access_level === 0,
    //   width: 160,
    // },
    // {
    //   field: 'progression',
    //   headerName: 'Progression',
    //   renderCell: renderProgress,
    //   editable: user.access_level === 0,
    //   width: 160,
    // }
    {
      field: "totalProgress",
      headerName: "Progression",
      renderCell: renderProgress,
      width: 160,
    },
  ];
  if (user.id_service === 4 || user.access_level === 0) {
    // if (formation.action_type === 'Programme intégré' && (formation.format === 'Mixte' || formation.format === 'Présentiel')) {
    //   columnsFinal.push({
    //     field: 'tlms_percentage',
    //     headerName: 'Progression tlms',
    //     renderCell: renderProgress,
    //     width: 160
    //   },);
    // }
    columnsFinal.push(
      {
        editable: user.access_level === 0,
        field: "duration",
        headerName: "Durée",
        renderCell: (cellValues) =>
          (cellValues.row.totalProgress === 100 ? cellValues.row.duration : ""),
        width: 120,
      }
    );
    // étape, durée
    // if (formation.format === 'Mixte' || formation.format === 'Présentiel') {
    //   columnsFinal.push({
    //     field: 'presence',
    //     headerName: 'Présence',
    //     renderCell: (cellValues) => (
    //       <Switch
    //         edge="end"
    //         checked={cellValues.row.presence}
    //         onChange={() => { cellValues.row.presence = !cellValues.row.presence; cellValues.value = cellValues.row.presence; handleChange(cellValues); }}
    //         defaultChecked={cellValues.row.presence}
    //         value={cellValues.row.presence}
    //         disabled={user.access_level !== 0}
    //       />
    //     ),
    //     editable: user.access_level === 0,
    //     width: 80,
    //   },);
    // }
  }
  columnsFinal.push(
    {
      field: "etat",
      headerName: "État",
      renderCell: (cellValues) => {
        let etat = "";
        if (parseInt(cellValues.row.progression, 10) === 100) {
          if (
            formation.format === "Mixte" ||
            formation.format === "Présentiel"
          ) {
            if (cellValues.row.presence) {
              etat = "Terminé";
            } else {
              etat = "En cours";
            }
          } else {
            etat = "Terminé";
          }
        } else if (
          parseInt(cellValues.row.progression, 10) < 100 &&
          parseInt(cellValues.row.progression, 10) > 0 &&
          session.end_date >= moment().format("YYYY-MM-DD")
        ) {
          etat = "En cours";
        } else if (
          parseInt(cellValues.row.progression, 10) < 100 &&
          parseInt(cellValues.row.progression, 10) > 0 &&
          session.end_date < moment().format("YYYY-MM-DD")
        ) {
          etat = "Non terminé";
        } else if (
          parseInt(cellValues.row.progression, 10) === 0 &&
          session.end_date >= moment().format("YYYY-MM-DD")
        ) {
          etat = "Pas commencé";
        } else if (
          parseInt(cellValues.row.progression, 10) === 0 &&
          session.end_date < moment().format("YYYY-MM-DD")
        ) {
          etat = "Non terminé";
        }
        if (!etat) return <Typography sx={{ fontSize: '0.78rem', color: 'text.disabled' }}>—</Typography>;
        const eStyle = getEtatStyle(etat);
        return <CellPill label={etat} color={eStyle.color} bg={eStyle.bg} border={eStyle.border} />;
      },
      width: 120,
    },
    {
      field: "financier_id",
      headerName: "Financeur",
      type: "singleSelect",
      valueOptions: (() => {
        // Ordre d'affichage imposé du financeur
        const order = ["DPC", "OPCO-EP", "Auto-financement", "FAFPM", "FIFPL-PCC", "FIFPL-PAIEMENT"];
        const byName = new Map(financiers.map(f => [f.name, { value: f.id, label: f.name }]));
        const opts = [];
        order.forEach(name => {
          if (name === "Auto-financement") {
            opts.push({ value: 0, label: "Auto-financement" });
          } else if (byName.has(name)) {
            opts.push(byName.get(name));
          }
        });
        // Tout financeur hors liste canonique est ajouté à la fin
        financiers.forEach(f => {
          if (!order.includes(f.name)) opts.push({ value: f.id, label: f.name });
        });
        return opts;
      })(),
      valueFormatter: (params) => {
        if (params.value === 0) return "Auto-financement";
        const financier = financiers.find(f => f.id === params.value);
        return financier ? financier.name : "Non défini";
      },
      editable: user.access_level === 0 || user.id_service === 4,
      width: 150,
    },
    {
      field: "real_price",
      headerName: "Prix",
      valueFormatter: (params) => `${params.value} €`,
      editable: user.access_level === 0 || user.id_service === 4,
      width: 100,
    },

    // {
    //   field: 'docs',
    //   headerName: 'Attestations & Conventions',
    //   type: 'text',
    //   renderCell: (cellValues) => {
    //     let component = '';
    //     component = (
    //       <>
    //         <Chip
    //         icon={<DoneAllOutlinedIcon color={getConventionSentStatus(cellValues.row.agreement_sent, cellValues.row.agreement_completed)} />}
    //         label="Convention"
    //         variant="outlined"
    //         size="small"
    //         sx={{ marginRight: '5px' }}
    //         />
    //         <Chip
    //         icon={<HorizontalRuleRoundedIcon color={getAttestationSentStatus(cellValues.row.honor_sent, cellValues.row.honor_completed)} />}
    //         label="Attestation sur honneur"
    //         variant="outlined"
    //         size="small"
    //         sx={{ marginRight: '5px' }}
    //       />
    //       <Chip
    //         icon={<AccessTimeOutlinedIcon color={getCertificateSentStatus(cellValues.row.certificate_sent)} />}
    //         label="Attestation DPC"
    //         variant="outlined"
    //         size="small"
    //         sx={{ marginRight: '5px' }}
    //       />
    //       </>
    //       );
    //     return (component);
    //   },
    //   editable: false,
    //   width: 420,
    // },
    // {
    //   field: 'downolad',
    //   headerName: 'Attestations & Conventions signées',
    //   type: 'text',
    //   renderCell: (cellValues) => {
    //     let statut = '';
    //     statut = (
    //       <>
    //         <Chip
    //           icon={<DownloadOutlinedIcon />}
    //           label="Convention"
    //           onClick={() => downloadSignedFileByTokenRequester(cellValues.row.agreement_token_requester)}
    //           variant="outlined"
    //           size="small"
    //           sx={{ marginRight: '5px' }}
    //           disabled={!cellValues.row.agreement_completed}
    //           />
    //         <Chip
    //           icon={<DownloadOutlinedIcon />}
    //           label="Attestation sur honneur"
    //           onClick={() => downloadSignedFileByTokenRequester(cellValues.row.honor_token_requester)}
    //           variant="outlined"
    //           size="small"
    //           sx={{ marginRight: '5px' }}
    //           disabled={!cellValues.row.honor_completed}
    //         />
    //       </>
    //       );
    //     return (statut);
    //   },
    //   editable: false,
    //   width: 300,
    // },
    {
      field: "source_id",
      headerName: "Source",
      type: "singleSelect",
      valueOptions: sources.map((source) => source.id),
      valueFormatter: (params) =>
        (sources.find((source) => source.id === params.value)
          ? `${
              sources.find((source) => source.id === params.value).firstname
            } ${sources.find((source) => source.id === params.value).lastname}`
          : ""),
      editable: user.access_level === 0 || user.id_service === 4,
      width: 125,
    }
  );
  if (user.id_service === 4 || user.access_level === 0) {
    columnsFinal.push({
      // {
      //   field: 'dateLastRelance',
      //   headerName: 'Dernière relance',
      //   width: 150,
      // },
      // {
      //   field: 'invoiced',
      //   headerName: 'Facturé',
      //   renderCell: (cellValues) => (
      //     <Switch
      //       edge="end"
      //       onChange={() => { cellValues.row.invoiced = !cellValues.row.invoiced; cellValues.value = cellValues.row.invoiced; handleChange(cellValues); }}
      //       defaultChecked={cellValues.row.invoiced}
      //       value={cellValues.row.invoiced}
      //       disabled={user.access_level !== 0}
      //     />
      //   ),
      //   editable: user.access_level === 0,
      //   width: 80,
      // }
      field: "comments",
      headerName: "Commentaire",
      renderCell: (cellValues) => (
        <Tooltip
          followCursor
          enterDelay={500}
          placement="top"
          title={
            <span style={{ whiteSpace: "pre-line" }}>
          {cellValues.row.comments}
            </span>
          }
        >
          <Typography color="textPrimary" variant="body2">
           {cellValues.row.comments}
          </Typography>
        </Tooltip>
      ),
      editable: user.access_level === 0 || user.id_service === 4,
      width: 140,
    });
    columnsFinal.push({
      field: "comments_logistique",
      headerName: "Commentaire logistique",
      renderCell: (cellValues) => (
        <Tooltip
          followCursor
          enterDelay={500}
          placement="top"
          title={
            <span style={{ whiteSpace: "pre-line" }}>
          {cellValues.row.comments_logistique}
            </span>
          }
        >
          <Typography color="textPrimary" variant="body2">
           {cellValues.row.comments_logistique}
          </Typography>
        </Tooltip>
      ),
      editable: user.access_level === 0 || user.id_service === 4,
      width: 220,
    });
    columnsFinal.push({
      field: "qualification",
      headerName: "Qualification",
      type: "singleSelect",
      valueOptions: [
        "sera présent",
        "sera absent",
        "relance en cours",
        "paiement confirmé",
        "paiement non reçu",
        "NRP",
        "NRP + Mail",
        "NRP + SMS",
        "NRP + WhatsApp"
      ],
      renderCell: (cellValues) => {
        if (!cellValues.value) return <Typography sx={{ fontSize: '0.78rem', color: 'text.disabled' }}>—</Typography>;
        const qStyle = getQualificationStyle(cellValues.value);
        return <CellPill label={cellValues.value} color={qStyle.color} bg={qStyle.bg} border={qStyle.border} />;
      },
      editable: user.access_level === 0 || user.id_service === 4,
      width: 180,
    });
    columnsFinal.push({
      field: "not_relaunch",
      headerName: "Ne pas relancer",
      width: 140,
    });
  }
  // statut appel, dernière relance, facturé
  if (user.id_service === 4 || user.access_level === 0) {
    columnsFinal.push({
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 150,
      cellClassName: "actions",
      getActions: (cellValues) => 
        [
          <>
          {/* <GridActionsCellItem
            icon={<ListIcon />}
            onClick={() => handleLogs(id)}
            label="Fichier log"
            disabled={(user.id_service !== 0 && user.access_level !== 0) || (moment().year() !== moment(session.end_date).year())}
          /> */}
          {/* Permet de déterminer si le profil de l'apprenant est complet avant envoi d'attestation */}
          {/* <div sx={{ marginRight: "10px" }}>
            {!hasCompletedProfile(cellValues.row) && (
              <AdjustOutlinedIcon sx={{ fontSize: 10, color: "red" }} />
            )}
          </div> */}
          <Tooltip title="Convention de formation">
            <GridActionsCellItem
              icon={<SendIcon />}
              onClick={() => {
                setDialogText(
                  !cellValues.row.agreement_sent
                    ? `Vous êtes sur le point d\'envoyer la convention de formation de l\'apprenant ${cellValues.row.firstname} ${cellValues.row.lastname} pour signature. Cliquez sur envoyer pour confirmer.`
                    : `Attention ! Ce document a déjà été envoyé et est en attente de signature.`
                );
                setDialogAction("send-agreement");
                setSelectedEngine(null);
                setOpenTooltip(false);
                setOpenCommonDialog(true);
                setCurrentRowLearnerSessionId(cellValues.row.id);
              }}
              label="Envoyer la convention"
              disabled={!hasCompletedProfile(cellValues.row)}
              style={{
                color: cellValues.row.agreement_completed
                  ? "#7EB627"
                  : cellValues.row.agreement_sent
                    ? "#4A86CE"
                    : "inherit",
              }} /></Tooltip>
        <><Tooltip title="Attestation de formation">
            <GridActionsCellItem
              icon={<AttachEmailIcon />}
              onClick={() => {
                setCurrentRowLearnerSessionId(cellValues.row.id);
                // Formation « certificat de décès » (prog. 520260720012) -> proposer le choix
                if (String(cellValues.row.program_number) === "520260720012") {
                  setCertChoiceRow(cellValues.row);
                  setOpenCertChoice(true);
                } else {
                  setDialogText(
                    !cellValues.row.certificate_sent
                      ? `Vous êtes sur le point d\'envoyer l\'attestation de fin de formation de l\'apprenant ${cellValues.row.firstname} ${cellValues.row.lastname} . Cliquez sur envoyer pour confirmer.`
                      : `Attention ! Ce document a déjà été envoyé et est en attente de signature.`
                  );
                  setDialogAction("send-certificate");
                  setOpenCommonDialog(true);
                }
              }}
              label="Attestation de formation"
              disabled={!hasCompletedProfile(cellValues.row)}
              style={{
                color: cellValues.row.certificate_sent
                  ? "#4A86CE"
                  : "inherit",
              }} />
          </Tooltip><Tooltip title="Attestation sur l'honneur">
              <GridActionsCellItem
                icon={<AssignmentIcon />}
                onClick={() => {
                  setDialogText(
                    !cellValues.row.honor_sent
                      ? `Vous êtes sur le point d\'envoyer l\'attestation sur l\'honneur à l\'apprenant ${cellValues.row.firstname} ${cellValues.row.lastname} . Cliquez sur envoyer pour confirmer.`
                      : `Attention ! Ce document a déjà été envoyé et est en attente de signature.`
                  );
                  setDialogAction("send-swarn-statement");
                  setOpenCommonDialog(true);
                  setCurrentRowLearnerSessionId(cellValues.row.id);
                }}
                label="Attestation sur l'honneur"
                disabled={!hasCompletedProfile(cellValues.row)}
                style={{
                  color: cellValues.row.honor_completed
                    ? "#7EB627"
                    : cellValues.row.honor_sent
                      ? "#4A86CE"
                      : "inherit",
                }} />
            </Tooltip><GridActionsCellItem
              icon={<DeleteIcon />}
              onClick={() => {
                setOpenDialogDelete(true);
                setCustomerToDeleteId(cellValues.row.id);
              }}
              label="Supprimer"
               /></>
              </>
      ],
    });
  } else {
    columnsFinal.push({
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 80,
      cellClassName: "actions",
      getActions: ({ id }) => [
        <GridActionsCellItem
          icon={<DeleteIcon />}
          onClick={() => {
            setOpenDialogDelete(true);
            setCustomerToDeleteId(id);
          }}
          label="Supprimer"
          disabled={user.id_service !== 0 && user.access_level !== 0}
        />,
      ],
    });
  }

  const handleTooltipClose = () => {
    setOpenTooltip(false);
  };

  const handleTooltipOpen = () => {
    setOpenTooltip(true);
  };
  // const columns = [
  //   {
  //     field: 'firstname',
  //     headerName: 'Prénom',
  //     renderCell: (cellValues) => (
  //       <Tooltip
  //         followCursor
  //         enterDelay={500}
  //         placement="top"
  //         title={(
  //           <span style={{ whiteSpace: 'pre-line' }}>
  //             Email:
  //             {' '}
  //             {cellValues.row.email}
  //             {'\n'}
  //             RPPS:
  //             {' '}
  //             {cellValues.row.adeli_rpps}
  //             {'\n'}
  //             Profession:
  //             {' '}
  //             {cellValues.row.profession}
  //             {'\n'}
  //             Inscription:
  //             {' '}
  //             {cellValues.row.subscribed_at !== null ? moment(cellValues.row.subscribed_at).format('DD/MM/YYYY HH:mm:ss') : ''}
  //           </span>
  //     )}
  //       >
  //         <Link
  //           component={RouterLink}
  //           to={`/dashboard/customers/${cellValues.row.customers_id}`}
  //           variant="subtitle2"
  //         >
  //           {cellValues.row.firstname}
  //         </Link>
  //       </Tooltip>
  //     ),
  //     width: 200,
  //   },
  //   {
  //     field: 'lastname',
  //     headerName: 'Nom',
  //     renderCell: (cellValues) => (
  //       <Tooltip
  //         followCursor
  //         enterDelay={500}
  //         placement="top"
  //         title={(
  //           <span style={{ whiteSpace: 'pre-line' }}>
  //             Email:
  //             {' '}
  //             {cellValues.row.email}
  //             {'\n'}
  //             RPPS:
  //             {' '}
  //             {cellValues.row.adeli_rpps}
  //             {'\n'}
  //             Profession:
  //             {' '}
  //             {cellValues.row.profession}
  //             {'\n'}
  //             Inscription:
  //             {' '}
  //             {cellValues.row.subscribed_at !== null ? moment(cellValues.row.subscribed_at).format('DD/MM/YYYY HH:mm:ss') : ''}
  //           </span>
  //       )}
  //       >
  //         <Link
  //           component={RouterLink}
  //           to={`/dashboard/customers/${cellValues.row.customers_id}`}
  //           variant="subtitle2"
  //         >
  //           {cellValues.row.lastname}
  //         </Link>
  //       </Tooltip>
  //     ),
  //     width: 200,
  //   },
  //   {
  //     field: 'status',
  //     headerName: 'Statut',
  //     type: 'singleSelect',
  //     renderCell: (cellValues) => {
  //       let statut = '';
  //       if (cellValues.row.status === 'Inscrit') {
  //         statut = (
  //           <Label
  //             color="success"
  //           >
  //             {cellValues.row.status}
  //           </Label>
  //         );
  //       } else if (cellValues.row.status === 'En attente' || cellValues.row.status === 'À transférer') {
  //         statut = (
  //           <Label
  //             color="warning"
  //           >
  //             {cellValues.row.status}
  //           </Label>
  //         );
  //       } else if (cellValues.row.status === 'InscritD') {
  //         statut = (
  //           <Tooltip
  //             followCursor
  //             enterDelay={500}
  //             color="inscritD"
  //             placement="top"
  //             title={cellValues.row.decalages !== undefined ? cellValues.row.decalages.map((dec) => (
  //               <span style={{ whiteSpace: 'pre-line' }}>
  //                 {`${dec.name} session: ${dec.number_session}`}
  //                 {'\n'}
  //               </span>
  //             )) : null}
  //           >
  //             <span>
  //               <Label
  //                 color="inscritD"
  //               >
  //                 {cellValues.row.status}
  //               </Label>
  //             </span>
  //           </Tooltip>
  //         );
  //       } else if (cellValues.row.status === 'Décalé') {
  //         statut = (
  //           <Tooltip
  //             followCursor
  //             enterDelay={500}
  //             placement="top"
  //             title={cellValues.row.decalages !== undefined ? cellValues.row.decalages.map((dec) => (
  //               <span style={{ whiteSpace: 'pre-line' }}>
  //                 {`${dec.name} session: ${dec.number_session}`}
  //                 {'\n'}
  //               </span>
  //             )) : null}
  //           >
  //             <span>
  //               <Label
  //                 InputLabelProps={{ style: { pointerEvents: 'auto' } }}
  //                 color="secondary"
  //               >
  //                 {cellValues.row.status}
  //               </Label>
  //             </span>
  //           </Tooltip>
  //         );
  //       } else if (cellValues.row.status === '- de 5 personnes' || cellValues.row.status === 'Annulation' || cellValues.row.status === 'À décaler') {
  //         statut = (
  //           <Label
  //             color="error"
  //           >
  //             {cellValues.row.status}
  //           </Label>
  //         );
  //       }
  //       return (statut);
  //     },
  //     editable: true,
  //     valueOptions: ['Inscrit', 'En attente', 'À décaler', 'Décalé', '- de 5 personnes', 'Annulation', 'À transférer'],
  //     width: 150,
  //   },
  //   {
  //     field: 'primary_connection',
  //     headerName: 'Première connexion',
  //     editable: user.access_level === 0,
  //     type: 'dateTime',
  //     width: 160,
  //   },
  //   {
  //     field: 'last_connection',
  //     headerName: 'Dernière connexion',
  //     type: 'dateTime',
  //     editable: user.access_level === 0,
  //     width: 160,
  //   },
  //   {
  //     field: 'progression',
  //     headerName: 'Progression',
  //     renderCell: renderProgress,
  //     editable: user.access_level === 0,
  //     width: 160,
  //   },
  //   {
  //     field: 'etat',
  //     headerName: 'État',
  //     renderCell: (cellValues) => {
  //       let etat = '';
  //       if (cellValues.row.progression === 100) {
  //         etat = 'Terminé';
  //       } else if (cellValues.row.progression < 100 && cellValues.row.progression > 0 && session.end_date >= moment().format('YYYY-MM-DD')) {
  //         etat = 'En cours';
  //       } else if (cellValues.row.progression < 100 && cellValues.row.progression > 0 && session.end_date < moment().format('YYYY-MM-DD')) {
  //         etat = 'Non terminé';
  //       } else if (cellValues.row.progression === 0 && session.end_date >= moment().format('YYYY-MM-DD')) {
  //         etat = 'Pas commencé';
  //       } else if (cellValues.row.progression === 0 && session.end_date < moment().format('YYYY-MM-DD')) { etat = 'Non terminé'; }
  //       return etat;
  //     },
  //     width: 120,
  //   },
  //   // {
  //   //   field: 'duration',
  //   //   headerName: 'Durée',
  //   //   editable: user.access_level === 0,
  //   //   width: 120,
  //   // },
  //   {
  //     field: 'real_price',
  //     headerName: 'Prix',
  //     valueFormatter: (params) => `${params.value} €`,
  //     editable: user.access_level === 0,
  //     width: 100,
  //   },
  //   {
  //     field: 'source_id',
  //     headerName: 'Source',
  //     type: 'singleSelect',
  //     valueOptions: sources.map((source) => source.id),
  //     valueFormatter: (params) => (sources.find((source) => source.id === params.value) ? `${sources.find((source) => source.id === params.value).firstname} ${sources.find((source) => source.id === params.value).lastname}` : ''),
  //     editable: user.access_level === 0,
  //     width: 125,
  //   },
  //   {
  //     field: 'actions',
  //     type: 'actions',
  //     headerName: 'Actions',
  //     width: 80,
  //     cellClassName: 'actions',
  //     getActions: ({ id }) => [

  //       <GridActionsCellItem
  //         icon={<DeleteIcon />}
  //         onClick={() => handleDelete(id)}
  //         label="Supprimer"
  //         disabled={user.id_service !== 0 && user.access_level !== 0}
  //       />
  //     ],
  //   },
  // ];

  // const columns2 = [
  //   {
  //     field: 'firstname',
  //     headerName: 'Prénom',
  //     renderCell: (cellValues) => (
  //       <Tooltip
  //         followCursor
  //         enterDelay={500}
  //         placement="top"
  //         title={(
  //           <span style={{ whiteSpace: 'pre-line' }}>
  //             Email:
  //             {' '}
  //             {cellValues.row.email}
  //             {'\n'}
  //             RPPS:
  //             {' '}
  //             {cellValues.row.adeli_rpps}
  //             {'\n'}
  //             Profession:
  //             {' '}
  //             {cellValues.row.profession}
  //             {'\n'}
  //             Inscription:
  //             {' '}
  //             {cellValues.row.subscribed_at !== null ? moment(cellValues.row.subscribed_at).format('DD/MM/YYYY HH:mm:ss') : ''}
  //           </span>
  //     )}
  //       >
  //         <Link
  //           component={RouterLink}
  //           to={`/dashboard/customers/${cellValues.row.customers_id}`}
  //           variant="subtitle2"
  //         >
  //           {cellValues.row.firstname}
  //         </Link>
  //       </Tooltip>
  //     ),
  //     width: 200,
  //   },
  //   {
  //     field: 'lastname',
  //     headerName: 'Nom',
  //     renderCell: (cellValues) => (
  //       <Tooltip
  //         followCursor
  //         enterDelay={500}
  //         placement="top"
  //         title={(
  //           <span style={{ whiteSpace: 'pre-line' }}>
  //             Email:
  //             {' '}
  //             {cellValues.row.email}
  //             {'\n'}
  //             RPPS:
  //             {' '}
  //             {cellValues.row.adeli_rpps}
  //             {'\n'}
  //             Profession:
  //             {' '}
  //             {cellValues.row.profession}
  //             {'\n'}
  //             Inscription:
  //             {' '}
  //             {cellValues.row.subscribed_at !== null ? moment(cellValues.row.subscribed_at).format('DD/MM/YYYY HH:mm:ss') : ''}
  //           </span>
  //       )}
  //       >
  //         <Link
  //           component={RouterLink}
  //           to={`/dashboard/customers/${cellValues.row.customers_id}`}
  //           variant="subtitle2"
  //         >
  //           {cellValues.row.lastname}
  //         </Link>
  //       </Tooltip>
  //     ),
  //     width: 200,
  //   },
  //   {
  //     field: 'status',
  //     headerName: 'Statut',
  //     type: 'singleSelect',
  //     renderCell: (cellValues) => {
  //       let statut = '';
  //       if (cellValues.row.status === 'Inscrit') {
  //         statut = (
  //           <Label
  //             color="success"
  //           >
  //             {cellValues.row.status}
  //           </Label>
  //         );
  //       } else if (cellValues.row.status === 'En attente' || cellValues.row.status === 'À transférer') {
  //         statut = (
  //           <Label
  //             color="warning"
  //           >
  //             {cellValues.row.status}
  //           </Label>
  //         );
  //       } else if (cellValues.row.status === 'InscritD') {
  //         statut = (
  //           <Tooltip
  //             followCursor
  //             enterDelay={500}
  //             color="inscritD"
  //             placement="top"
  //             title={cellValues.row.decalages !== undefined ? cellValues.row.decalages.map((dec) => (
  //               <span style={{ whiteSpace: 'pre-line' }}>
  //                 {`${dec.name} session: ${dec.number_session}`}
  //                 {'\n'}
  //               </span>
  //             )) : null}
  //           >
  //             <span>
  //               <Label
  //                 color="inscritD"
  //               >
  //                 {cellValues.row.status}
  //               </Label>
  //             </span>
  //           </Tooltip>
  //         );
  //       } else if (cellValues.row.status === 'Décalé') {
  //         statut = (
  //           <Tooltip
  //             followCursor
  //             enterDelay={500}
  //             placement="top"
  //             title={cellValues.row.decalages !== undefined ? cellValues.row.decalages.map((dec) => (
  //               <span style={{ whiteSpace: 'pre-line' }}>
  //                 {`${dec.name} session: ${dec.number_session}`}
  //               </span>
  //             )) : null}
  //           >
  //             <Label
  //               color="secondary"
  //             >
  //               {cellValues.row.status}
  //             </Label>
  //           </Tooltip>
  //         );
  //       } else if (cellValues.row.status === '- de 5 personnes' || cellValues.row.status === 'Annulation' || cellValues.row.status === 'À décaler') {
  //         statut = (
  //           <Label
  //             color="error"
  //           >
  //             {cellValues.row.status}
  //           </Label>
  //         );
  //       }
  //       return (statut);
  //     },
  //     editable: true,
  //     valueOptions: ['Inscrit', 'En attente', 'À décaler', 'Décalé', '- de 5 personnes', 'Annulation'],
  //     width: 80,
  //   },
  //   {
  //     field: 'primary_connection',
  //     headerName: 'Première connexion',
  //     width: 160,
  //   },
  //   {
  //     field: 'last_connection',
  //     headerName: 'Dernière connexion',
  //     width: 160,
  //   },
  //   {
  //     field: 'progression',
  //     headerName: 'Progression',
  //     renderCell: renderProgress,
  //     width: 160,
  //   },
  // ];

  // if (formation.action_type === 'Programme intégré' && (formation.format === 'Mixte' || formation.format === 'Non présentiel')) {
  //   columns2.push({
  //     field: 'tlms_percentage',
  //     headerName: 'Progression tlms',
  //     renderCell: renderProgress,
  //     width: 160
  //   },);
  // }

  // columns2.push(
  //   { field: 'step',
  //     headerName: 'Étape',
  //     width: 160
  //   },
  //   {
  //     editable: user.access_level === 0,
  //     field: 'duration',
  //     headerName: 'Durée',
  //     // type: 'date',
  //     width: 120,
  //   },
  //   {
  //     field: 'real_price',
  //     headerName: 'Prix',
  //     valueFormatter: (params) => `${params.value} €`,
  //     editable: user.access_level === 0,
  //     width: 100,
  //   },
  //   {
  //     field: 'source_id',
  //     headerName: 'Source',
  //     type: 'singleSelect',
  //     valueOptions: sources.map((source) => source.id),
  //     valueFormatter: (params) => (sources.find((source) => source.id === params.value) ? `${sources.find((source) => source.id === params.value).firstname} ${sources.find((source) => source.id === params.value).lastname}` : ''),
  //     editable: true,
  //     width: 125,
  //   },
  //   {
  //     field: 'call_track_relance',
  //     headerName: 'Statut d\'appel',
  //     renderCell: (cellValues) => (
  //       <Tooltip
  //         followCursor
  //         enterDelay={500}
  //         placement="top"
  //         title={(
  //           <span style={{ whiteSpace: 'pre-line' }}>
  //             {cellValues.row.call_track_relance[0] !== undefined ? cellValues.row.call_track_relance[0].map((ctr) => `${ctr.status} ${moment(ctr.date).format('DD/MM/YYYY HH:mm:ss')}\n`) : ''}
  //           </span>
  //   )}
  //       >
  //         <Typography
  //           color="textPrimary"
  //           variant="body2"
  //         >
  //           {cellValues.row.call_track_relance[0] !== undefined ? cellValues.row.call_track_relance[0][0].status !== null ? cellValues.row.call_track_relance[0][0].status : '' : ''}
  //         </Typography>
  //       </Tooltip>
  //     ),
  //     width: 140,
  //   },
  //   {
  //     field: 'dateLastRelance',
  //     headerName: 'Dernière relance',
  //     width: 150,
  //   },
  //   {
  //     field: 'invoiced',
  //     headerName: 'Facturé',
  //     renderCell: (cellValues) => (
  //       <Switch
  //         edge="end"
  //         onChange={() => { cellValues.row.invoiced = !cellValues.row.invoiced; cellValues.value = cellValues.row.invoiced; handleChange(cellValues); }}
  //         defaultChecked={cellValues.row.invoiced}
  //         value={cellValues.row.invoiced}
  //         disabled={user.access_level !== 0}
  //       />
  //     ),
  //     editable: user.access_level === 0,
  //     width: 80,
  //   },
  //   {
  //     field: 'actions',
  //     type: 'actions',
  //     headerName: 'Actions',
  //     width: 80,
  //     cellClassName: 'actions',
  //     getActions: ({ id }) => [
  //       <GridActionsCellItem
  //         icon={<ListIcon />}
  //         onClick={() => handleLogs(id)}
  //         label="Fichier log"
  //         disabled={(user.id_service !== 0 && user.access_level !== 0) || (moment().year() !== moment(session.end_date).year())}
  //       />,
  //       <GridActionsCellItem
  //         icon={<DeleteIcon />}
  //         onClick={() => handleDelete(id)}
  //         label="Supprimer"
  //       />,
  //     ],
  //   },
  // );

  return (
    <>
      <Formik
      initialValues={{ addCustomer: null }}
      enableReinitialize
      validationSchema={Yup.object().shape({
        addCustomer: Yup.number().nullable(),
      })}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
          if (values.addCustomer !== null) {
            const jsonAnswer = await sessionApi.addCustomer(
              sessionId,
              user.id,
              values,
              localStorage.getItem("accessToken")
            );
            setStatus({ success: true });
            setSubmitting(false);
            toast.success("Apprenant inscrit !");
            const tempCustomers = [...customers];
            tempCustomers.unshift(jsonAnswer.data);
            setCustomers(tempCustomers);
            values.addCustomer = null;
          }
        } catch (err) {
          console.error(err);
          toast.error("Il y a eu un souci lors de l'inscription !");
          setStatus({ success: false });
          setErrors({ submit: err.message });
          setSubmitting(false);
        }
      }}
    >
      {({ errors, handleSubmit, isSubmitting, touched, setFieldValue }) => (
        <form onSubmit={handleSubmit}>
          <Card
            {...other}
            sx={{
              border: '1px solid',
              borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.6)' : 'rgba(255, 255, 255, 0.06)',
              borderRadius: '24px',
              overflow: 'hidden',
              boxShadow: theme.palette.mode === 'light' ? '0 12px 40px rgba(15, 23, 42, 0.05)' : '0 12px 40px rgba(0, 0, 0, 0.3)',
              background: theme.palette.mode === 'light' ? '#fff' : 'rgba(30, 41, 59, 0.45)',
            }}
          >
            <Dialog
              open={openCertChoice}
              onClose={() => setOpenCertChoice(false)}
            >
              <DialogTitle>Choix de l'attestation</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  {`Quelle attestation souhaitez-vous envoyer à ${certChoiceRow?.firstname || ""} ${certChoiceRow?.lastname || ""} ?`}
                </DialogContentText>
              </DialogContent>
              <DialogActions sx={{ flexWrap: "wrap", gap: 1, p: 2 }}>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    setOpenCertChoice(false);
                    setDialogText(
                      !certChoiceRow?.certificate_sent
                        ? `Vous êtes sur le point d'envoyer l'attestation de fin de formation de l'apprenant ${certChoiceRow?.firstname} ${certChoiceRow?.lastname} . Cliquez sur envoyer pour confirmer.`
                        : `Attention ! Ce document a déjà été envoyé et est en attente de signature.`
                    );
                    setDialogAction("send-certificate");
                    setOpenCommonDialog(true);
                  }}
                >
                  Attestation globale
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    setOpenCertChoice(false);
                    setDialogText(
                      !certChoiceRow?.certificate_sent
                        ? `Vous êtes sur le point d'envoyer l'attestation « certificat de décès » à l'apprenant ${certChoiceRow?.firstname} ${certChoiceRow?.lastname} . Cliquez sur envoyer pour confirmer.`
                        : `Attention ! Ce document a déjà été envoyé et est en attente de signature.`
                    );
                    setDialogAction("send-death-certificate");
                    setOpenCommonDialog(true);
                  }}
                >
                  Attestation certificat de décès
                </Button>
                <Button onClick={() => setOpenCertChoice(false)} color="inherit">
                  Annuler
                </Button>
              </DialogActions>
            </Dialog>
            <Dialog
              open={openCommonDialog}
              onClose={() => setOpenCommonDialog(false)}
            >
              <DialogContent>
                <DialogContentText>{dialogText}</DialogContentText>
                {(dialogAction === "send-agreement" ||
                  dialogAction === "send-multiple-agreements") && (
                  <Box sx={{ mt: 2 }}>
                    <Typography
                      sx={{ fontWeight: 700, fontSize: "0.85rem", mb: 1 }}
                    >
                      Moteur de signature
                    </Typography>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      <Chip
                        label="SES"
                        size="small"
                        color={
                          selectedEngine === "internal" ? "primary" : "default"
                        }
                        variant={
                          selectedEngine === "internal" ? "filled" : "outlined"
                        }
                        onClick={() => setSelectedEngine("internal")}
                      />
                      <Chip
                        label="I LOVE PDF"
                        size="small"
                        color={
                          selectedEngine === "ilovepdf" ? "primary" : "default"
                        }
                        variant={
                          selectedEngine === "ilovepdf" ? "filled" : "outlined"
                        }
                        onClick={() => setSelectedEngine("ilovepdf")}
                      />
                    </Box>
                  </Box>
                )}
              </DialogContent>
              {/* <DialogActions>
                <Button
                  onClick={() => {
                    if (dialogAction === 'send-agreement') {
                      downloadAgrement(currentRowLearnerSessionId);
                    } else if (dialogAction === 'send-certificate') {
                      downloadCertificate(currentRowLearnerSessionId);
                    } else if (dialogAction === 'send-swarn-statement') {
                      downloadSwarnStatement(currentRowLearnerSessionId);
                    }
                  }}
                  color="primary"
                  disabled={isLoading}
                >
                  Télécharger
                </Button>
                <ClickAwayListener onClickAway={handleTooltipClose}>
                  <Tooltip
                    onClose={handleTooltipClose}
                    open={openTooltip}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title={(
                    <Alert
                      icon={false}
                      style={{ backgroundColor: theme.palette.mode !== 'light' && 'transparent' }}
                      sx={{ margin: 0 }}
                    >
                      <Grid
                        container
                        spacing={0}
                      >
                        <Grid
                          item
                          sx={8}
                        >
                          Attention - Cette action est irréversible !
                        </Grid>
                        <Grid
                          item
                          sx={4}
                        >
                          <Button
                            onClick={() => {
                              if (dialogAction === 'send-agreement') {
                                sendAgreement(currentRowLearnerSessionId);
                              } else if (dialogAction === 'send-certificate') {
                                sendCertificate(currentRowLearnerSessionId);
                              } else if (dialogAction === 'send-swarn-statement') {
                                sendSwarnStatement(currentRowLearnerSessionId);
                              }
                            }}
                            color="secondary"
                            variant="outlined"
                            size="small"
                            sx={{ mt: 1 }}
                            disabled={isLoading}
                          >
                            Confirmer
                          </Button>
                        </Grid>
                      </Grid>
                    </Alert>
                  )}
                  >
                    <Button 
                      color="primary"
                      onClick={handleTooltipOpen}>
                      Je souhaite envoyer
                    </Button>
                  </Tooltip>
                </ClickAwayListener>
                <Button
                  onClick={() => setOpenCommonDialog(false)}
                  color="primary"
                >
                  Annuler
                </Button>
                {isLoading && (
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center'
                  }}
                >
                  <CircularProgress />
                </Box>
                )}
              </DialogActions> */}
              <DialogActions>
                <Chip
                  sx={{ padding: 1 }}
                  label="Télécharger"
                  variant="outlined"
                  icon={<DownloadOutlinedIcon />}
                  size="small"
                  onClick={() => {
                    switch (dialogAction) {
                      case "send-agreement":
                        downloadAgrement(currentRowLearnerSessionId);
                        break;
                      case "send-certificate":
                        downloadCertificate(currentRowLearnerSessionId);
                        break;
                      case "send-swarn-statement":
                        downloadSwarnStatement(currentRowLearnerSessionId);
                        break;
                      case "send-multiple-agreements":
                        downloadMultipleAgreements();
                        break;
                      case "send-multiple-swarn-statements":
                        downloadMultipleSwarnStatements();
                        break;
                      case "send-multiple-certificates":
                        downloadMultipleCertificates();
                        break;
                      default:
                        // Optionnel : gérer les cas non définis ou ajouter un message d'erreur si nécessaire
                        console.warn("Action inconnue : ", dialogAction);
                        break;
                    }
                  }}
                  disabled={isLoading}
                />
                {(dialogAction === "send-multiple-certificates" ||
                  dialogAction === "send-certificate") && (
                  <Chip
                    sx={{ padding: 1 }}
                    label="Télécharger pdf"
                    variant="outlined"
                    icon={<DownloadOutlinedIcon />}
                    size="small"
                    onClick={() => {
                      if (dialogAction === "send-certificate") {
                        downloadCertificateToPdf(currentRowLearnerSessionId);
                      } else if (
                        dialogAction === "send-multiple-certificates"
                      ) {
                        downloadMultipleCertificatesToPdf();
                      }
                    }}
                    disabled={isLoading}
                  />
                )}
               <ClickAwayListener onClickAway={handleTooltipClose}>
                  <Tooltip
                    onClose={handleTooltipClose}
                    open={openTooltip}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title={
                      <Alert
                        icon={false}
                        style={{
                          backgroundColor: theme?.palette?.mode !== "light" ? "transparent" : undefined,
                        }}
                        sx={{ margin: 0 }}
                      >
                        <Grid container spacing={0}>
                          <Grid item sx={8}>
                            {(dialogAction === "send-agreement" ||
                              dialogAction === "send-multiple-agreements") &&
                            !selectedEngine
                              ? "Choisissez d'abord le moteur de signature ci-dessus."
                              : "Attention - Cette action est irréversible !"}
                          </Grid>
                          <Grid item sx={4}>
                            <Button
                              onClick={() => {
                                // Les actions en lot (send-multiple-*) n'ont pas de currentRowLearnerSessionId
                                if (
                                  !isLoading &&
                                  dialogAction &&
                                  (currentRowLearnerSessionId ||
                                    dialogAction.startsWith("send-multiple"))
                                ) {
                                  switch (dialogAction) {
                                    case "send-agreement":
                                      sendAgreement(currentRowLearnerSessionId, selectedEngine);
                                      break;
                                    case "send-certificate":
                                      sendCertificate(currentRowLearnerSessionId);
                                      break;
                                    case "send-death-certificate":
                                      sendDeathCertificate(currentRowLearnerSessionId);
                                      break;
                                    case "send-swarn-statement":
                                      sendSwarnStatement(currentRowLearnerSessionId);
                                      break;
                                    case "send-multiple-agreements":
                                      sendMultipleAgreements(selectedEngine);
                                      break;
                                    case "send-multiple-swarn-statements":
                                      sendMultipleSwarnStatements();
                                      break;
                                    case "send-multiple-certificates":
                                      sendMultipleCertificates();
                                      break;
                                    case "send-multiple-fifpl":
                                      sendMultipleFifplCertificates();
                                      break;
                                    default:
                                      break;
                                  }
                                }
                              }}
                              color="secondary"
                              variant="outlined"
                              size="small"
                              sx={{ mt: 1 }}
                              disabled={
                                isLoading ||
                                ((dialogAction === "send-agreement" ||
                                  dialogAction === "send-multiple-agreements") &&
                                  !selectedEngine)
                              }
                            >
                              Confirmer
                            </Button>
                          </Grid>
                        </Grid>
                      </Alert>
                    }
                  >
                    <Chip
                      sx={{ padding: 1 }}
                      label="Je souhaite envoyer"
                      icon={<SendIcon />}
                      variant="outlined"
                      color="primary"
                      size="small"
                      onClick={handleTooltipOpen}
                    />
                    {/* <Chip
                      sx={{ padding: 1 }}
                      label="Télécharger le fichier signé"
                      icon={<DownloadOutlinedIcon />}
                      variant="outlined"
                      color="primary"
                      size="small"
                      onClick={downloadSignedFileByTokenRequester}
                    /> */}
                  </Tooltip>
                </ClickAwayListener>
                <Chip
                  sx={{ padding: 1 }}
                  label="Annuler"
                  variant="outlined"
                  size="small"
                  onClick={() => setOpenCommonDialog(false)}
                />
                {isLoading && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress />
                  </Box>
                )}
              </DialogActions>
            </Dialog>
            <Dialog
              open={openDialogDelete}
              onClose={() => setOpenDialogDelete(false)}
            >
              <DialogContent>
                <DialogContentText>
                  Souhaitez-vous vraiment supprimer l&apos;apprenant de la session ?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => handleDelete(customerToDeleteId)}
                  color="primary"
                  disabled={isLoading}
                >
                  Supprimer
                </Button>
                <Button
                  onClick={() => setOpenDialogDelete(false)}
                  color="primary"
                >
                  Annuler
                </Button>
                {isLoading && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress />
                  </Box>
                )}
              </DialogActions>
            </Dialog>
            <Dialog open={showDec} onClose={handleCloseDialog}>
              <DialogTitle>Décalage</DialogTitle>
              <DialogContent>
                <Box sx={{ mb: 2 }}>
                  <Stepper activeStep={activeDecalageStep} alternativeLabel>
                    <Step>
                      <StepLabel>Choix de la formation</StepLabel>
                    </Step>
                    <Step>
                      <StepLabel>Récapitulatif</StepLabel>
                    </Step>
                  </Stepper>
                </Box>
                {activeDecalageStep === 0 && (
                  <Box>
                    <Typography variant="subtitle1" gutterBottom>
                      Formations où l'apprenant est déjà inscrit (année en cours)
                    </Typography>
                    <Grid container spacing={2} sx={{ mb: 2 }}>
                      {loadingExistingEnrolled && (
                        <Grid item xs={12}>
                          <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                            <CircularProgress size={20} />
                          </Box>
                        </Grid>
                      )}
                      {!loadingExistingEnrolled && existingEnrolledFormations.length === 0 && (
                        <Grid item xs={12}>
                          <Alert severity="info">Aucune formation avec statut Inscrit trouvée pour l'année en cours.</Alert>
                        </Grid>
                      )}
                      {existingEnrolledFormations
                        .map((f) => (
                        <Grid item xs={12} sm={6} md={4} key={`${f.session_id}-${f.number_session}`}>
                          <Card
                            onClick={() => setSelectedExistingFormation(f)}
                            style={{
                              cursor: 'pointer',
                              border: selectedExistingFormation && selectedExistingFormation.session_id === f.session_id ? '2px solid #1976d2' : '1px solid rgba(0,0,0,0.12)'
                            }}
                          >
                            <Box p={2}>
                              <Typography variant="subtitle2">{f.name}</Typography>
                              <Typography variant="body2">Session {f.number_session}</Typography>
                              <Typography variant="caption">Début: {moment(f.start_date).format('DD/MM/YYYY')} • Fin: {moment(f.end_date).format('DD/MM/YYYY')}</Typography>
                            </Box>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                    <Typography variant="subtitle1" gutterBottom>
                      Ou choisir une autre formation
                    </Typography>
                    <Grid container spacing={3}>
                      <Grid item xs width={600}>
                        <Autocomplete
                          getOptionLabel={(option) =>
                            `${option.name} ${option.program_number}`
                          }
                          options={formations}
                          onChange={(e, value) => {
                            if (value !== null) {
                              setDisableChoiceSession(false);
                              setIndexFormationDec(formations.indexOf(value));
                              setFieldValue("choiceFormation", value.id);
                            } else {
                              setDisableChoiceSession(true);
                              setIndexFormationDec(0);
                            }
                            setSelectedExistingFormation(null);
                            setSessionDecState(null);
                            sessionDec = 0;
                            setValueIdSession(!valueIdSession);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              label="Choisir une formation"
                              name="choiceFormation"
                              variant="outlined"
                            />
                          )}
                        />
                      </Grid>
                      <Grid item xs width={600}>
                        <Autocomplete
                          // pour réinitialiser le autocomplete on lui change la valeur de sa key, quand on change de formation, cela réinitialise le champ
                          key={valueIdSession}
                          getOptionLabel={(option) =>
                            `${option.number_session}. Début: ${moment(
                              option.start_date
                            ).format("DD/MM/YYYY")}, Fin: ${moment(
                              option.end_date
                            ).format("DD/MM/YYYY")}`
                          }
                          options={formations[indexFormationDec].sessions}
                          onChange={(e, value) => {
                            setFieldValue(
                              "choiceSession",
                              value !== null ? value.id : null
                            );
                            sessionDec = value ? value.id : null;
                            setSessionDecState(value ? value.id : null);
                            setSelectedExistingFormation(null);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              fullWidth
                              label="Choisir une session"
                              name="choiceFormation"
                              variant="outlined"
                              disabled={disableChoiceSession}
                            />
                          )}
                        />
                      </Grid>
                    </Grid>
                  </Box>
                )}
                {activeDecalageStep === 1 && (
                  <Box>
                    <Typography variant="subtitle2" gutterBottom>Récapitulatif</Typography>
                    <Box sx={{ whiteSpace: 'pre-line' }}>
                      <Typography variant="body2">
                        Source: {formation?.name} • Session {session?.number_session} • {moment(session?.start_date).format('DD/MM/YYYY')} → {moment(session?.end_date).format('DD/MM/YYYY')}
                      </Typography>
                      {selectedExistingFormation ? (
                        <Typography variant="body2">
                          Cible: {selectedExistingFormation.name} • Session {selectedExistingFormation.number_session} • {moment(selectedExistingFormation.start_date).format('DD/MM/YYYY')} → {moment(selectedExistingFormation.end_date).format('DD/MM/YYYY')}
                        </Typography>
                      ) : (
                        <Typography variant="body2">
                          Cible: {formations[indexFormationDec]?.name} • Session sélectionnée ID {sessionDecState}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                )}
              </DialogContent>
              <DialogActions>
                {activeDecalageStep > 0 && (
                  <Button onClick={() => setActiveDecalageStep((s) => s - 1)} color="primary">
                    Retour
                  </Button>
                )}
                <Button onClick={handleCloseDialog} color="primary">
                  Annuler
                </Button>
                {activeDecalageStep === 0 && (
                  <Button
                    onClick={() => {
                      if (!selectedExistingFormation && !sessionDecState) {
                        toast.error('Veuillez sélectionner une formation ou une session.');
                        return;
                      }
                      setActiveDecalageStep(1);
                    }}
                    color="primary"
                  >
                    Suivant
                  </Button>
                )}
                {activeDecalageStep === 1 && (
                  <Button
                    onClick={async () => {
                      if (selectedExistingFormation) {
                        if (typeof handleDecalageFromStatus === 'function') {
                          try {
                            await handleDecalageFromStatus(currentIdDec, selectedExistingFormation.session_id);
                            handleCloseDialog();
                          } catch (e) {
                            // laisser la gestion d'erreur au callback si besoin
                          }
                        } else {
                          toast.error("Action non disponible: handleDecalageFromStatus non fourni.");
                        }
                        return;
                      }
                      await handleDecalage();
                    }}
                    color="primary"
                  >
                    Valider
                  </Button>
                )}
              </DialogActions>
            </Dialog>
            <Dialog open={showEmails} onClose={() => setShowEmails(false)}>
            <DialogTitle>Email de relance (version bêta)</DialogTitle>
              <DialogContent>
                <DialogContentText>
                Vous êtes sur le point d'envoyer {selectedRows.length} emails. Quel mail souhaitez-vous envoyer ?
                  </DialogContentText>
                </DialogContent>
              <DialogActions>
                <Button onClick={() => sendEmails('reminder_epp')} color="primary">
                  Relance EPP
                </Button>
                <Button onClick={() => sendEmails('reminder_pi')} color="primary">
                  Relance PI
                </Button>
                <Button onClick={() => sendEmails('reminder_fc')} color="primary">
                  Relance FC
                </Button>
              </DialogActions>
            </Dialog>
            {/* <Dialog
              open={showAlert}
              onClose={handleCloseDialog}
            >
              <DialogTitle>
                Différence de dates
              </DialogTitle>
              <DialogContent>
                <DialogContentText>
                  <span style={{ whiteSpace: 'pre-line' }}>
                    {alertMessage}
                  </span>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={handleCloseDialog}
                  color="primary"
                >
                  Annuler
                </Button>
              </DialogActions>
            </Dialog> */}
            {!show && (
              <Button
                onClick={handleShow}
                sx={primaryBtnSx}
                variant="contained"
                disableElevation
                disabled={user.access_level !== 0}
              >
                + Ajouter un apprenant
              </Button>
              // <Chip
              //   color="primary"
              //   label="+ Ajouter un apprenant"
              //   variant="outlined"
              //   sx={{
              //     mb: 2,
              //     mt: 2,
              //     ml: 1,
              //   }}
              //   onClick={handleShow}
              // />
            )}
            {show && (
              <>
                <Grid item md={4} sx={12}>
                  <Autocomplete
                    filterOptions={(x) => x}
                    loading={isSearchingCustomers}
                    onInputChange={(event, newInputValue) => {
                      setCustomerSearchQuery(newInputValue);
                    }}
                    noOptionsText={customerSearchQuery.length < 3 ? "Tapez au moins 3 caractères" : "Aucun apprenant trouvé"}
                    key={isSubmitting}
                    getOptionLabel={(option) =>
                      `${option.firstname} ${option.lastname}`
                    }
                    options={customerSearchOptions.filter(
                      (customer) =>
                        !customers
                          .map((c) => c.customers_id)
                          .includes(customer.id)
                    )}
                    onChange={(e, value) => {
                      setFieldValue(
                        "addCustomer",
                        value !== null ? value.id : null
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        error={Boolean(
                          touched.addCustomer && errors.addCustomer
                        )}
                        fullWidth
                        helperText={touched.addCustomer && errors.addCustomer}
                        label="Chercher un apprenant à ajouter"
                        name="addCustomer"
                        variant="outlined"
                      />
                    )}
                  />
                </Grid>
                <Button
                  disabled={isSubmitting}
                  sx={primaryBtnSx}
                  variant="contained"
                  disableElevation
                  type="submit"
                >
                  Ajouter l&apos;apprenant
                </Button>
                <Button
                  sx={actionBtnSx}
                  variant="outlined"
                  onClick={handleShow}
                >
                  Fermer l&apos;ajout
                </Button>
              </>
            )}
            <Button
              onClick={handleDowloadAttendanceList}
              sx={actionBtnSx}
              variant="outlined"
              disabled={user.access_level !== 0  && user.id_service !== 4}
            >
              Télécharger la liste de présence
            </Button>
            <Button
              onClick={handleUpdateAttestationsAndConventionsCompletionState}
              sx={actionBtnSx}
              variant="outlined"
              disabled={user.access_level !== 0 && user.id_service !== 4}
            >
              Actualiser les états d'envoi de conventions & attestations
            </Button>
            {/* <Chip
              icon={<DownloadOutlinedIcon />}
              color="primary"
              label="Télécharger la liste de présence"
              variant="outlined"
              sx={{
                mt: 2,
                mb: 2,
                ml: 1,
              }}
              onClick={handleDowloadAttendanceList}
            />
            <Chip
              icon={<CachedRoundedIcon />}
              color="primary"
              label="Actualiser les états d'envoi de conventions & attestations"
              variant="outlined"
              sx={{
                mt: 2,
                mb: 2,
                ml: 1,
              }}
              onClick={handleUpdateAttestationsAndConventionsCompletionState}
            /> */}
            {selectedRows.length > 0 && (
              <>
                <Button
                  startIcon={<FolderZipIcon />}
                  color="primary"
                  onClick={() => {
                    setDialogText(
                      `Vous êtes sur le point d\'envoyer ${selectedRows.length} conventions. Voulez-vous continuer ?`
                    );
                    setDialogAction("send-multiple-agreements");
                    setSelectedEngine(null);
                    setOpenTooltip(false);
                    setOpenCommonDialog(true);
                  }}
                  sx={actionBtnSx}
                  variant="outlined"
                  disabled={user.access_level !== 0}
                >
                  Conventions
                </Button>
                {/* <Button
                  endIcon={<DownloadOutlinedIcon />}
                  color="primary"
                  onClick={downloadMultipleAgreements}
                  sx={actionBtnSx}
                  variant="outlined"
                  disabled={user.access_level !== 0}
                >
                  Conventions
                </Button> */}
                <Button
                  startIcon={<FolderZipIcon />}
                  color="primary"
                  onClick={() => {
                    setDialogText(
                      `Vous êtes sur le point d\'envoyer ${selectedRows.length} attestations sur honneur. Voulez-vous continuer ?`
                    );
                    setDialogAction("send-multiple-swarn-statements");
                    setOpenCommonDialog(true);
                  }}
                  sx={actionBtnSx}
                  variant="outlined"
                  disabled={user.access_level !== 0}
                >
                  Attestations sur honneur
                </Button>
                {/* <Button
                  endIcon={<DownloadOutlinedIcon />}
                  color="primary"
                  onClick={downloadMultipleSwarnStatements}
                  sx={actionBtnSx}
                  variant="outlined"
                  disabled={user.access_level !== 0}
                >
                  Attestations sur honneur
                </Button> */}
                <Button
                  startIcon={<FolderZipIcon />}
                  color="primary"
                  onClick={() => {
                    setDialogText(
                      `Vous êtes sur le point d\'envoyer ${selectedRows.length} certificats de réussite. Voulez-vous continuer ?`
                    );
                    setDialogAction("send-multiple-certificates");
                    setOpenCommonDialog(true);
                  }}
                  sx={actionBtnSx}
                  variant="outlined"
                  disabled={user.access_level !== 0}
                >
                  Certificats
                </Button>
                {selectedRows.some((row) => row.financier_id === 4) && (
                  <Tooltip title="Attestation de présence et de règlement FIF-PL">
                    <Button
                      startIcon={<FolderZipIcon />}
                      color="primary"
                      onClick={() => {
                        const nb = selectedRows.filter(
                          (row) => row.financier_id === 4
                        ).length;
                        setDialogText(
                          `Vous êtes sur le point d\'envoyer ${nb} attestation(s) FIF-PL (présence et règlement). Voulez-vous continuer ?`
                        );
                        setDialogAction("send-multiple-fifpl");
                        setOpenCommonDialog(true);
                      }}
                      sx={actionBtnSx}
                      variant="outlined"
                      disabled={user.access_level !== 0}
                    >
                      APR
                    </Button>
                  </Tooltip>
                )}
                <Button
                  startIcon={<SendIcon />}
                  onClick={() => setShowSessionEmailDialog(true)}
                  sx={actionBtnSx}
                  variant="outlined"
                  disabled={![0, 4].includes(user.id_service)}
                >
                  Email
                </Button>
                {/* <Chip
                    icon={<UploadOutlinedIcon />}
                    color="primary"
                    label="Conventions"
                    variant="outlined"
                    sx={{
                      mt: 2,
                      mb: 2,
                      ml: 1,
                    }}
                    onClick={sendMultipleAgreements}
                  />
                  <Chip
                    icon={<UploadOutlinedIcon />}
                    color="primary"
                    label="Attestations sur horneur"
                    variant="outlined"
                    sx={{
                      mb: 2,
                      mt: 2,
                      ml: 1,
                    }}
                    onClick={sendMultipleSwarnStatements}
                  /> */}
              </>
            )}
            {/* <Button
              color="primary"
              sx={{
                mt: 2,
                ml: 1,
              }}
              variant="outlined"
              onClick={handleExportPlateforme}
              disabled
            >
              Exporter vers la plateforme
            </Button> */}
            {/* <Button
              color="primary"
              onClick={handleGetAttestationsDPC}
              sx={{ m: 1 }}
              variant="outlined"
              disabled={user.access_level !== 0}
            >
              Générer les attestations DPC
            </Button>
            <Button
              color="primary"
              onClick={handleGetTracabilite}
              sx={{ m: 1 }}
              variant="outlined"
              disabled={user.access_level !== 0 || moment().year() !== moment(session.end_date).year()}
            >
              Générer la traçabilité
            </Button> */}

            {/* {isLoading && (
              <Box sx={{ width: "100%", my: 2 }}>
                <LinearProgress
                  variant="buffer"
                  value={progress}
                  valueBuffer={buffer}
                />
              </Box>
            )} */}

            <Box sx={{ width: '100%' }}>
            <div className="w-auto min-w-fit">
              <DataGrid
                localeText={frFR.components.MuiDataGrid.defaultProps.localeText}
                initialState={{
                  sorting: {
                    sortModel: [{ field: "lastname", sort: "asc" }],
                  },
                }}
                autoHeight
                rowHeight={64}
                disableVirtualization
                sx={{
                  overflowX: 'auto',
                  display: 'grid',
                  gridTemplateRows: 'auto 1f auto',
                  border: 'none',
                  fontFamily: 'inherit',
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: theme.palette.mode === 'light' ? 'rgba(248, 250, 252, 0.9)' : 'rgba(15, 23, 42, 0.4)',
                    borderBottom: '1px solid',
                    borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)',
                    borderRadius: 0,
                  },
                  '& .MuiDataGrid-columnHeaderTitle': {
                    fontWeight: 800,
                    fontSize: '0.7rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.06em',
                    color: 'text.secondary',
                  },
                  '& .MuiDataGrid-columnSeparator': { display: 'none' },
                  '& .MuiDataGrid-row:nth-of-type(even)': {
                    backgroundColor: theme.palette.mode === 'light' ? 'rgba(248, 250, 252, 0.45)' : 'rgba(255, 255, 255, 0.015)',
                  },
                  '& .MuiDataGrid-row': {
                    transition: 'background-color 0.15s ease, box-shadow 0.15s ease',
                  },
                  '& .MuiDataGrid-row:hover': {
                    backgroundColor: theme.palette.mode === 'light' ? 'rgba(59, 130, 246, 0.05)' : 'rgba(59, 130, 246, 0.09)',
                    boxShadow: 'inset 3px 0 0 0 #3b82f6',
                  },
                  '& .MuiDataGrid-cell': {
                    borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.4)' : 'rgba(255, 255, 255, 0.04)',
                    display: 'flex !important',
                    alignItems: 'center !important',
                  },
                  '& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within': { outline: 'none !important' },
                  '& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within': { outline: 'none !important' },
                  '& .MuiDataGrid-footerContainer': {
                    borderTop: '1px solid',
                    borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)',
                    backgroundColor: theme.palette.mode === 'light' ? 'rgba(248, 250, 252, 0.5)' : 'rgba(15, 23, 42, 0.3)',
                  },
                  '& .MuiCheckbox-root.Mui-checked': { color: '#3b82f6' },
                  '& .MuiDataGrid-toolbarContainer': {
                    p: 1.5,
                    gap: 0.5,
                    borderBottom: '1px solid',
                    borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.7)' : 'rgba(255, 255, 255, 0.06)',
                    backgroundColor: theme.palette.mode === 'light' ? 'rgba(248, 250, 252, 0.5)' : 'rgba(15, 23, 42, 0.25)',
                    '& .MuiButton-root': {
                      color: '#3b82f6',
                      fontWeight: 700,
                      fontSize: '0.78rem',
                      textTransform: 'none',
                      borderRadius: '10px',
                      '&:hover': { backgroundColor: 'rgba(59, 130, 246, 0.08)' },
                    },
                  },
                  '& .MuiDataGrid-columnHeaderCheckbox, & .MuiDataGrid-columnHeader[data-field="__check__"]': {
                    position: 'sticky !important',
                    left: '0 !important',
                    backgroundColor: theme.palette.mode === 'light' ? '#f8fafc' : '#0f172a',
                    zIndex: '5 !important',
                  },
                  '& .MuiDataGrid-columnHeader[data-field="lastname"]': {
                    position: 'sticky !important',
                    left: '50px !important',
                    backgroundColor: theme.palette.mode === 'light' ? '#f8fafc' : '#0f172a',
                    zIndex: '5 !important',
                    borderRight: '1px solid',
                    borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)',
                  },
                  '& .MuiDataGrid-cellCheckbox, & .MuiDataGrid-cell[data-field="__check__"]': {
                    position: 'sticky !important',
                    left: '0 !important',
                    backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1a202c',
                    zIndex: '3 !important',
                  },
                  '& .MuiDataGrid-cell[data-field="lastname"]': {
                    position: 'sticky !important',
                    left: '50px !important',
                    backgroundColor: theme.palette.mode === 'light' ? '#fff' : '#1a202c',
                    zIndex: '3 !important',
                    borderRight: '1px solid',
                    borderColor: theme.palette.mode === 'light' ? 'rgba(226, 232, 240, 0.8)' : 'rgba(255, 255, 255, 0.08)',
                    boxShadow: '4px 0 8px -4px rgba(0, 0, 0, 0.1)',
                  },
                  '& .MuiDataGrid-row:nth-of-type(even) .MuiDataGrid-cellCheckbox, & .MuiDataGrid-row:nth-of-type(even) .MuiDataGrid-cell[data-field="__check__"]': {
                    backgroundColor: theme.palette.mode === 'light' ? '#f8fafc' : '#141d2b',
                  },
                  '& .MuiDataGrid-row:nth-of-type(even) .MuiDataGrid-cell[data-field="lastname"]': {
                    backgroundColor: theme.palette.mode === 'light' ? '#f8fafc' : '#141d2b',
                  },
                  '& .MuiDataGrid-row:hover .MuiDataGrid-cellCheckbox, & .MuiDataGrid-row:hover .MuiDataGrid-cell[data-field="__check__"]': {
                    backgroundColor: theme.palette.mode === 'light' ? '#f1f5f9' : '#1e293b',
                  },
                  '& .MuiDataGrid-row:hover .MuiDataGrid-cell[data-field="lastname"]': {
                    backgroundColor: theme.palette.mode === 'light' ? '#f1f5f9' : '#1e293b',
                  },
                  '& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cellCheckbox, & .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell[data-field="__check__"]': {
                    backgroundColor: theme.palette.mode === 'light' ? '#e2e8f0' : '#2d3748',
                  },
                  '& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell[data-field="lastname"]': {
                    backgroundColor: theme.palette.mode === 'light' ? '#e2e8f0' : '#2d3748',
                  },
                  '& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cellCheckbox, & .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell[data-field="__check__"]': {
                    backgroundColor: theme.palette.mode === 'light' ? '#cbd5e1' : '#3a4a63',
                  },
                  '& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell[data-field="lastname"]': {
                    backgroundColor: theme.palette.mode === 'light' ? '#cbd5e1' : '#3a4a63',
                  },
                }}
                rows={rows}
                // columns={user.id_service === 4 || user.access_level === 0 ? columns2 : columns}
                columns={columnsFinal}
                pageSize={100}
                checkboxSelection
                rowsPerPageOptions={[5]}
                onCellEditCommit={handleChange}
                onSelectionModelChange={(ids) => {
                  const selectedIDs = new Set(ids);
                  const _selectedRows = rows.filter((row) =>
                    selectedIDs.has(row.id)
                  );
                  setSelectedRows(_selectedRows);
                }}
                components={{ Toolbar: CustomToolbar }}
                    
              />
              </div>
            </Box>
          </Card>
        </form>
      )}
    </Formik>
    
    {/* Dialog stepper pour l'envoi d'emails de session */}
    <SessionEmailSendDialog
      open={showSessionEmailDialog}
      onClose={() => setShowSessionEmailDialog(false)}
      session={session}
      customers={selectedRows}
      formation={formation}
    />
  </>
  );
};

SessionCustomerListTable.propTypes = {
  customersFixed: PropTypes.array.isRequired,
  sessionId: PropTypes.number.isRequired,
  getSession: PropTypes.func,
  customersList: PropTypes.array.isRequired,
  session: PropTypes.object.isRequired,
  formation: PropTypes.object.isRequired,
  sources: PropTypes.array.isRequired,
  relanceFixed: PropTypes.array,
  orientations: PropTypes.array.isRequired,
  formations: PropTypes.array.isRequired,
  setShowCheckUserDataAlert: PropTypes.bool.isRequired,
};

export default SessionCustomerListTable;
